! function(t) {
    function e(n) {
        if (r[n]) return r[n].exports;
        var o = r[n] = {
            exports: {},
            id: n,
            loaded: !1
        };
        return t[n].call(o.exports, o, o.exports, e), o.loaded = !0, o.exports
    }
    var r = {};
    return e.m = t, e.c = r, e.p = "", e(0)
}([function(t, e, r) {
    r(1), t.exports = r(3)
}, function(t, e, r) {
    var n, o;
    (function(i) {
        "use strict";
        var a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol ? "symbol" : typeof t
        };
        /*!
         * https://github.com/paulmillr/es6-shim
         * @license es6-shim Copyright 2013-2015 by Paul Miller (http://paulmillr.com)
         *   and contributors,  MIT License
         * es6-shim: v0.27.1
         * see https://github.com/paulmillr/es6-shim/blob/0.27.1/LICENSE
         * Details and documentation:
         * https://github.com/paulmillr/es6-shim/
         */
        ! function(i, a) {
            n = a, o = "function" == typeof n ? n.call(e, r, e, t) : n, !(void 0 !== o && (t.exports = o))
        }(void 0, function() {
            function t(t) {
                var e = [];
                for (var r in t) e.push(r);
                return e
            }
            var e, r = function(t) {
                    return function() {
                        return !t.apply(this, arguments)
                    }
                },
                n = function(t) {
                    try {
                        return t(), !1
                    } catch (e) {
                        return !0
                    }
                },
                o = function(t) {
                    try {
                        return t()
                    } catch (e) {
                        return !1
                    }
                },
                s = r(n),
                u = function() {
                    return !n(function() {
                        Object.defineProperty({}, "x", {})
                    })
                },
                c = !!Object.defineProperty && u(),
                l = Function.call.bind(Array.prototype.forEach),
                f = Function.call.bind(Array.prototype.map),
                p = Function.call.bind(Array.prototype.reduce),
                h = Function.call.bind(Array.prototype.filter),
                y = function(t, e, r, n) {
                    !n && e in t || (c ? Object.defineProperty(t, e, {
                        configurable: !0,
                        enumerable: !1,
                        writable: !0,
                        value: r
                    }) : t[e] = r)
                },
                d = function(t, e) {
                    l(Object.keys(e), function(r) {
                        var n = e[r];
                        y(t, r, n, !1)
                    })
                },
                v = Object.create || function(t, e) {
                    function r() {}
                    r.prototype = t;
                    var n = new r;
                    return "undefined" != typeof e && d(n, e), n
                },
                b = function(t, e) {
                    return !!Object.setPrototypeOf && o(function() {
                        var r = function n(e) {
                            var r = new t(e);
                            return Object.setPrototypeOf(r, n.prototype), r
                        };
                        return r.prototype = v(t.prototype, {
                            constructor: {
                                value: t
                            }
                        }), e(r)
                    })
                },
                g = function() {
                    return String.prototype.startsWith && n(function() {
                        "/a/".startsWith(/a/)
                    })
                },
                m = function() {
                    return String.prototype.startsWith && "abc".startsWith("a", 1 / 0) === !1
                }(),
                w = new Function("return this;"),
                S = w(),
                j = S.isFinite,
                O = (function() {
                    return null === this
                }.call(null), g() && m),
                x = Function.call.bind(String.prototype.indexOf),
                k = Function.call.bind(Object.prototype.toString),
                T = Function.call.bind(Object.prototype.hasOwnProperty),
                M = function() {},
                E = S.Symbol || {},
                _ = E.species || "@@species",
                I = {
                    object: function(t) {
                        return null !== t && "object" === ("undefined" == typeof t ? "undefined" : a(t))
                    },
                    string: function(t) {
                        return "[object String]" === k(t)
                    },
                    regex: function(t) {
                        return "[object RegExp]" === k(t)
                    },
                    symbol: function(t) {
                        return "function" == typeof S.Symbol && "symbol" === ("undefined" == typeof t ? "undefined" : a(t))
                    }
                },
                P = Number.isNaN || function(t) {
                    return t !== t
                },
                C = Number.isFinite || function(t) {
                    return "number" == typeof t && j(t)
                },
                N = {
                    getter: function(t, e, r) {
                        if (!c) throw new TypeError("getters require true ES5 support");
                        Object.defineProperty(t, e, {
                            configurable: !0,
                            enumerable: !1,
                            get: r
                        })
                    },
                    proxy: function(t, e, r) {
                        if (!c) throw new TypeError("getters require true ES5 support");
                        var n = Object.getOwnPropertyDescriptor(t, e);
                        Object.defineProperty(r, e, {
                            configurable: n.configurable,
                            enumerable: n.enumerable,
                            get: function() {
                                return t[e]
                            },
                            set: function(r) {
                                t[e] = r
                            }
                        })
                    },
                    redefine: function(t, e, r) {
                        if (c) {
                            var n = Object.getOwnPropertyDescriptor(t, e);
                            n.value = r, Object.defineProperty(t, e, n)
                        } else t[e] = r
                    },
                    preserveToString: function(t, e) {
                        y(t, "toString", e.toString.bind(e), !0)
                    }
                },
                A = function(t, e, r) {
                    var n = t[e];
                    y(t, e, r, !0), N.preserveToString(t[e], n)
                },
                z = I.symbol(E.iterator) ? E.iterator : "_es6-shim iterator_";
            S.Set && "function" == typeof(new S.Set)["@@iterator"] && (z = "@@iterator");
            var F = function(t, e) {
                    var r = e || function() {
                            return this
                        },
                        n = {};
                    n[z] = r, d(t, n), !t[z] && I.symbol(z) && (t[z] = r)
                },
                L = function(t) {
                    var e = k(t),
                        r = "[object Arguments]" === e;
                    return r || (r = "[object Array]" !== e && null !== t && "object" === ("undefined" == typeof t ? "undefined" : a(t)) && "number" == typeof t.length && t.length >= 0 && "[object Function]" === k(t.callee)), r
                },
                R = Function.call.bind(Function.apply),
                W = {
                    Call: function(t, e) {
                        var r = arguments.length > 2 ? arguments[2] : [];
                        if (!W.IsCallable(t)) throw new TypeError(t + " is not a function");
                        return R(t, e, r)
                    },
                    RequireObjectCoercible: function(t, e) {
                        if (null == t) throw new TypeError(e || "Cannot call method on " + t)
                    },
                    TypeIsObject: function(t) {
                        return null != t && Object(t) === t
                    },
                    ToObject: function(t, e) {
                        return W.RequireObjectCoercible(t, e), Object(t)
                    },
                    IsCallable: function(t) {
                        return "function" == typeof t && "[object Function]" === k(t)
                    },
                    ToInt32: function(t) {
                        return W.ToNumber(t) >> 0
                    },
                    ToUint32: function(t) {
                        return W.ToNumber(t) >>> 0
                    },
                    ToNumber: function(t) {
                        if ("[object Symbol]" === k(t)) throw new TypeError("Cannot convert a Symbol value to a number");
                        return +t
                    },
                    ToInteger: function(t) {
                        var e = W.ToNumber(t);
                        return P(e) ? 0 : 0 !== e && C(e) ? (e > 0 ? 1 : -1) * Math.floor(Math.abs(e)) : e
                    },
                    ToLength: function(t) {
                        var e = W.ToInteger(t);
                        return e <= 0 ? 0 : e > Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : e
                    },
                    SameValue: function(t, e) {
                        return t === e ? 0 !== t || 1 / t === 1 / e : P(t) && P(e)
                    },
                    SameValueZero: function(t, e) {
                        return t === e || P(t) && P(e)
                    },
                    IsIterable: function(t) {
                        return W.TypeIsObject(t) && ("undefined" != typeof t[z] || L(t))
                    },
                    GetIterator: function(t) {
                        if (L(t)) return new e(t, "value");
                        var r = t[z];
                        if (!W.IsCallable(r)) throw new TypeError("value is not an iterable");
                        var n = r.call(t);
                        if (!W.TypeIsObject(n)) throw new TypeError("bad iterator");
                        return n
                    },
                    IteratorNext: function(t) {
                        var e = arguments.length > 1 ? t.next(arguments[1]) : t.next();
                        if (!W.TypeIsObject(e)) throw new TypeError("bad iterator");
                        return e
                    },
                    Construct: function(t, e) {
                        var r;
                        r = W.IsCallable(t[_]) ? t[_]() : v(t.prototype || null), d(r, {
                            _es6construct: !0
                        });
                        var n = W.Call(t, r, e);
                        return W.TypeIsObject(n) ? n : r
                    },
                    CreateHTML: function(t, e, r, n) {
                        var o = String(t),
                            i = "<" + e;
                        if ("" !== r) {
                            var a = String(n),
                                s = a.replace(/"/g, '"');
                            i += " " + r + '="' + s + '"'
                        }
                        var u = i + ">",
                            c = u + o;
                        return c + "</" + e + ">"
                    }
                },
                G = function(t) {
                    if (!W.TypeIsObject(t)) throw new TypeError("bad object");
                    var e = t;
                    return e._es6construct || (e.constructor && W.IsCallable(e.constructor[_]) && (e = e.constructor[_](e)), d(e, {
                        _es6construct: !0
                    })), e
                };
            if (String.fromCodePoint && 1 !== String.fromCodePoint.length) {
                var H = Function.apply.bind(String.fromCodePoint);
                A(String, "fromCodePoint", function(t) {
                    return H(this, arguments)
                })
            }
            var D = {
                fromCodePoint: function(t) {
                    for (var e, r = [], n = 0, o = arguments.length; n < o; n++) {
                        if (e = Number(arguments[n]), !W.SameValue(e, W.ToInteger(e)) || e < 0 || e > 1114111) throw new RangeError("Invalid code point " + e);
                        e < 65536 ? r.push(String.fromCharCode(e)) : (e -= 65536, r.push(String.fromCharCode((e >> 10) + 55296)), r.push(String.fromCharCode(e % 1024 + 56320)))
                    }
                    return r.join("")
                },
                raw: function(t) {
                    var e = W.ToObject(t, "bad callSite"),
                        r = W.ToObject(e.raw, "bad raw value"),
                        n = r.length,
                        o = W.ToLength(n);
                    if (o <= 0) return "";
                    for (var i, a, s, u, c = [], l = 0; l < o && (i = String(l), s = String(r[i]), c.push(s), !(l + 1 >= o));) a = l + 1 < arguments.length ? arguments[l + 1] : "", u = String(a), c.push(u), l++;
                    return c.join("")
                }
            };
            d(String, D), "xy" !== String.raw({
                raw: {
                    0: "x",
                    1: "y",
                    length: 2
                }
            }) && A(String, "raw", D.raw);
            var $ = function Je(t, e) {
                    if (e < 1) return "";
                    if (e % 2) return Je(t, e - 1) + t;
                    var r = Je(t, e / 2);
                    return r + r
                },
                U = 1 / 0,
                V = {
                    repeat: function(t) {
                        W.RequireObjectCoercible(this);
                        var e = String(this),
                            r = W.ToInteger(t);
                        if (r < 0 || r >= U) throw new RangeError("repeat count must be less than infinity and not overflow maximum string size");
                        return $(e, r)
                    },
                    startsWith: function(t) {
                        W.RequireObjectCoercible(this);
                        var e = String(this);
                        if (I.regex(t)) throw new TypeError('Cannot call method "startsWith" with a regex');
                        var r = String(t),
                            n = arguments.length > 1 ? arguments[1] : void 0,
                            o = Math.max(W.ToInteger(n), 0);
                        return e.slice(o, o + r.length) === r
                    },
                    endsWith: function(t) {
                        W.RequireObjectCoercible(this);
                        var e = String(this);
                        if (I.regex(t)) throw new TypeError('Cannot call method "endsWith" with a regex');
                        var r = String(t),
                            n = e.length,
                            o = arguments.length > 1 ? arguments[1] : void 0,
                            i = "undefined" == typeof o ? n : W.ToInteger(o),
                            a = Math.min(Math.max(i, 0), n);
                        return e.slice(a - r.length, a) === r
                    },
                    includes: function(t) {
                        var e = arguments.length > 1 ? arguments[1] : void 0;
                        return x(this, t, e) !== -1
                    },
                    codePointAt: function(t) {
                        W.RequireObjectCoercible(this);
                        var e = String(this),
                            r = W.ToInteger(t),
                            n = e.length;
                        if (r >= 0 && r < n) {
                            var o = e.charCodeAt(r),
                                i = r + 1 === n;
                            if (o < 55296 || o > 56319 || i) return o;
                            var a = e.charCodeAt(r + 1);
                            return a < 56320 || a > 57343 ? o : 1024 * (o - 55296) + (a - 56320) + 65536
                        }
                    }
                };
            d(String.prototype, V), "a".includes("a", 1 / 0) !== !1 && A(String.prototype, "includes", V.includes);
            var q = 1 !== "".trim().length;
            if (q) {
                delete String.prototype.trim;
                var Z = ["\t\n\x0B\f\r   ᠎    ", "         　\u2028", "\u2029\ufeff"].join(""),
                    X = new RegExp("(^[" + Z + "]+)|([" + Z + "]+$)", "g");
                d(String.prototype, {
                    trim: function() {
                        if ("undefined" == typeof this || null === this) throw new TypeError("can't convert " + this + " to object");
                        return String(this).replace(X, "")
                    }
                })
            }
            var B = function(t) {
                W.RequireObjectCoercible(t), this._s = String(t), this._i = 0
            };
            B.prototype.next = function() {
                var t = this._s,
                    e = this._i;
                if ("undefined" == typeof t || e >= t.length) return this._s = void 0, {
                    value: void 0,
                    done: !0
                };
                var r, n, o = t.charCodeAt(e);
                return o < 55296 || o > 56319 || e + 1 === t.length ? n = 1 : (r = t.charCodeAt(e + 1), n = r < 56320 || r > 57343 ? 1 : 2), this._i = e + n, {
                    value: t.substr(e, n),
                    done: !1
                }
            }, F(B.prototype), F(String.prototype, function() {
                return new B(this)
            }), O || (A(String.prototype, "startsWith", V.startsWith), A(String.prototype, "endsWith", V.endsWith));
            var J = {
                from: function(t) {
                    var e = arguments.length > 1 ? arguments[1] : void 0,
                        r = W.ToObject(t, "bad iterable");
                    if ("undefined" != typeof e && !W.IsCallable(e)) throw new TypeError("Array.from: when provided, the second argument must be a function");
                    var n, o, i, a, s = arguments.length > 2,
                        u = s ? arguments[2] : void 0,
                        c = W.IsIterable(r);
                    if (c) {
                        i = 0, o = W.IsCallable(this) ? Object(new this) : [];
                        var l, f = c ? W.GetIterator(r) : null;
                        do l = W.IteratorNext(f), l.done || (a = l.value, e ? o[i] = s ? e.call(u, a, i) : e(a, i) : o[i] = a, i += 1); while (!l.done);
                        n = i
                    } else
                        for (n = W.ToLength(r.length), o = W.IsCallable(this) ? Object(new this(n)) : new Array(n), i = 0; i < n; ++i) a = r[i], e ? o[i] = s ? e.call(u, a, i) : e(a, i) : o[i] = a;
                    return o.length = n, o
                },
                of: function() {
                    return Array.from.call(this, arguments)
                }
            };
            d(Array, J);
            var K = function(t) {
                return {
                    value: t,
                    done: 0 === arguments.length
                }
            };
            e = function(t, e) {
                this.i = 0, this.array = t, this.kind = e
            }, d(e.prototype, {
                next: function() {
                    var t = this.i,
                        r = this.array;
                    if (!(this instanceof e)) throw new TypeError("Not an ArrayIterator");
                    if ("undefined" != typeof r)
                        for (var n = W.ToLength(r.length); t < n; t++) {
                            var o, i = this.kind;
                            return "key" === i ? o = t : "value" === i ? o = r[t] : "entry" === i && (o = [t, r[t]]), this.i = t + 1, {
                                value: o,
                                done: !1
                            }
                        }
                    return this.array = void 0, {
                        value: void 0,
                        done: !0
                    }
                }
            }), F(e.prototype);
            var Y = function(t, e) {
                this.object = t, this.array = null, this.kind = e
            };
            d(Y.prototype, {
                next: function() {
                    var e, r = this.array;
                    if (!(this instanceof Y)) throw new TypeError("Not an ObjectIterator");
                    for (null === r && (r = this.array = t(this.object)); W.ToLength(r.length) > 0;)
                        if (e = r.shift(), e in this.object) return K("key" === this.kind ? e : "value" === this.kind ? this.object[e] : [e, this.object[e]]);
                    return K()
                }
            }), F(Y.prototype);
            var Q = function() {
                var t = function(t) {
                    this.length = t
                };
                t.prototype = [];
                var e = Array.of.apply(t, [1, 2]);
                return e instanceof t && 2 === e.length
            }();
            Q || A(Array, "of", J.of);
            var tt = {
                copyWithin: function(t, e) {
                    var r = arguments[2],
                        n = W.ToObject(this),
                        o = W.ToLength(n.length),
                        i = W.ToInteger(t),
                        a = W.ToInteger(e),
                        s = i < 0 ? Math.max(o + i, 0) : Math.min(i, o),
                        u = a < 0 ? Math.max(o + a, 0) : Math.min(a, o);
                    r = "undefined" == typeof r ? o : W.ToInteger(r);
                    var c = r < 0 ? Math.max(o + r, 0) : Math.min(r, o),
                        l = Math.min(c - u, o - s),
                        f = 1;
                    for (u < s && s < u + l && (f = -1, u += l - 1, s += l - 1); l > 0;) T(n, u) ? n[s] = n[u] : delete n[u], u += f, s += f, l -= 1;
                    return n
                },
                fill: function(t) {
                    var e = arguments.length > 1 ? arguments[1] : void 0,
                        r = arguments.length > 2 ? arguments[2] : void 0,
                        n = W.ToObject(this),
                        o = W.ToLength(n.length);
                    e = W.ToInteger("undefined" == typeof e ? 0 : e), r = W.ToInteger("undefined" == typeof r ? o : r);
                    for (var i = e < 0 ? Math.max(o + e, 0) : Math.min(e, o), a = r < 0 ? o + r : r, s = i; s < o && s < a; ++s) n[s] = t;
                    return n
                },
                find: function(t) {
                    var e = W.ToObject(this),
                        r = W.ToLength(e.length);
                    if (!W.IsCallable(t)) throw new TypeError("Array#find: predicate must be a function");
                    for (var n, o = arguments.length > 1 ? arguments[1] : null, i = 0; i < r; i++)
                        if (n = e[i], o) {
                            if (t.call(o, n, i, e)) return n
                        } else if (t(n, i, e)) return n
                },
                findIndex: function(t) {
                    var e = W.ToObject(this),
                        r = W.ToLength(e.length);
                    if (!W.IsCallable(t)) throw new TypeError("Array#findIndex: predicate must be a function");
                    for (var n = arguments.length > 1 ? arguments[1] : null, o = 0; o < r; o++)
                        if (n) {
                            if (t.call(n, e[o], o, e)) return o
                        } else if (t(e[o], o, e)) return o;
                    return -1
                },
                keys: function() {
                    return new e(this, "key")
                },
                values: function() {
                    return new e(this, "value")
                },
                entries: function() {
                    return new e(this, "entry")
                }
            };
            if (Array.prototype.keys && !W.IsCallable([1].keys().next) && delete Array.prototype.keys, Array.prototype.entries && !W.IsCallable([1].entries().next) && delete Array.prototype.entries, Array.prototype.keys && Array.prototype.entries && !Array.prototype.values && Array.prototype[z] && (d(Array.prototype, {
                    values: Array.prototype[z]
                }), I.symbol(E.unscopables) && (Array.prototype[E.unscopables].values = !0)), Array.prototype.values && "values" !== Array.prototype.values.name) {
                var et = Array.prototype.values;
                A(Array.prototype, "values", function() {
                    return et.call(this)
                }), y(Array.prototype, z, Array.prototype.values, !0)
            }
            d(Array.prototype, tt), F(Array.prototype, function() {
                return this.values()
            }), Object.getPrototypeOf && F(Object.getPrototypeOf([].values()));
            var rt = function() {
                    return o(function() {
                        return 0 === Array.from({
                            length: -1
                        }).length
                    })
                }(),
                nt = function() {
                    var t = Array.from([0].entries());
                    return 1 === t.length && 0 === t[0][0] && 1 === t[0][1]
                }();
            rt && nt || A(Array, "from", J.from);
            var ot = function(t, e) {
                var r = {
                    length: -1
                };
                return r[e ? 4294967294 : 0] = !0, o(function() {
                    t.call(r, function() {
                        throw new RangeError("should not reach here")
                    }, [])
                })
            };
            if (!ot(Array.prototype.forEach)) {
                var it = Array.prototype.forEach;
                A(Array.prototype, "forEach", function(t) {
                    return it.apply(this.length >= 0 ? this : [], arguments)
                }, !0)
            }
            if (!ot(Array.prototype.map)) {
                var at = Array.prototype.map;
                A(Array.prototype, "map", function(t) {
                    return at.apply(this.length >= 0 ? this : [], arguments)
                }, !0)
            }
            if (!ot(Array.prototype.filter)) {
                var st = Array.prototype.filter;
                A(Array.prototype, "filter", function(t) {
                    return st.apply(this.length >= 0 ? this : [], arguments)
                }, !0)
            }
            if (!ot(Array.prototype.some)) {
                var ut = Array.prototype.some;
                A(Array.prototype, "some", function(t) {
                    return ut.apply(this.length >= 0 ? this : [], arguments)
                }, !0)
            }
            if (!ot(Array.prototype.every)) {
                var ct = Array.prototype.every;
                A(Array.prototype, "every", function(t) {
                    return ct.apply(this.length >= 0 ? this : [], arguments)
                }, !0)
            }
            if (!ot(Array.prototype.reduce)) {
                var lt = Array.prototype.reduce;
                A(Array.prototype, "reduce", function(t) {
                    return lt.apply(this.length >= 0 ? this : [], arguments)
                }, !0)
            }
            if (!ot(Array.prototype.reduceRight, !0)) {
                var ft = Array.prototype.reduceRight;
                A(Array.prototype, "reduceRight", function(t) {
                    return ft.apply(this.length >= 0 ? this : [], arguments)
                }, !0)
            }
            var pt = Math.pow(2, 53) - 1;
            d(Number, {
                MAX_SAFE_INTEGER: pt,
                MIN_SAFE_INTEGER: -pt,
                EPSILON: 2.220446049250313e-16,
                parseInt: S.parseInt,
                parseFloat: S.parseFloat,
                isFinite: C,
                isInteger: function(t) {
                    return C(t) && W.ToInteger(t) === t
                },
                isSafeInteger: function(t) {
                    return Number.isInteger(t) && Math.abs(t) <= Number.MAX_SAFE_INTEGER
                },
                isNaN: P
            }), y(Number, "parseInt", S.parseInt, Number.parseInt !== S.parseInt), [, 1].find(function(t, e) {
                return 0 === e
            }) || A(Array.prototype, "find", tt.find), 0 !== [, 1].findIndex(function(t, e) {
                return 0 === e
            }) && A(Array.prototype, "findIndex", tt.findIndex);
            var ht = Function.bind.call(Function.bind, Object.prototype.propertyIsEnumerable),
                yt = function() {
                    for (var t = Number(this), e = arguments.length, r = e - t, n = new Array(r < 0 ? 0 : r), o = t; o < e; ++o) n[o - t] = arguments[o];
                    return n
                },
                dt = function(t) {
                    return function(e, r) {
                        return e[r] = t[r], e
                    }
                },
                vt = function(t, e) {
                    var r, n = Object.keys(Object(e));
                    return W.IsCallable(Object.getOwnPropertySymbols) && (r = h(Object.getOwnPropertySymbols(Object(e)), ht(e))), p(n.concat(r || []), dt(e), t)
                },
                bt = {
                    assign: function(t, e) {
                        if (!W.TypeIsObject(t)) throw new TypeError("target must be an object");
                        return p(yt.apply(0, arguments), vt)
                    },
                    is: function(t, e) {
                        return W.SameValue(t, e)
                    }
                },
                gt = Object.assign && Object.preventExtensions && function() {
                    var t = Object.preventExtensions({
                        1: 2
                    });
                    try {
                        Object.assign(t, "xy")
                    } catch (e) {
                        return "y" === t[1]
                    }
                }();
            if (gt && A(Object, "assign", bt.assign), d(Object, bt), c) {
                var mt = {
                    setPrototypeOf: function(t, e) {
                        var r, n = function(t, e) {
                                if (!W.TypeIsObject(t)) throw new TypeError("cannot set prototype on a non-object");
                                if (null !== e && !W.TypeIsObject(e)) throw new TypeError("can only set prototype to an object or null" + e)
                            },
                            o = function(t, e) {
                                return n(t, e), r.call(t, e), t
                            };
                        try {
                            r = t.getOwnPropertyDescriptor(t.prototype, e).set, r.call({}, null)
                        } catch (i) {
                            if (t.prototype !== {} [e]) return;
                            r = function(t) {
                                this[e] = t
                            }, o.polyfill = o(o({}, null), t.prototype) instanceof t
                        }
                        return o
                    }(Object, "__proto__")
                };
                d(Object, mt)
            }
            Object.setPrototypeOf && Object.getPrototypeOf && null !== Object.getPrototypeOf(Object.setPrototypeOf({}, null)) && null === Object.getPrototypeOf(Object.create(null)) && ! function() {
                var t = Object.create(null),
                    e = Object.getPrototypeOf,
                    r = Object.setPrototypeOf;
                Object.getPrototypeOf = function(r) {
                    var n = e(r);
                    return n === t ? null : n
                }, Object.setPrototypeOf = function(e, n) {
                    var o = null === n ? t : n;
                    return r(e, o)
                }, Object.setPrototypeOf.polyfill = !1
            }();
            var wt = !n(function() {
                Object.keys("foo")
            });
            if (!wt) {
                var St = Object.keys;
                A(Object, "keys", function(t) {
                    return St(W.ToObject(t))
                })
            }
            if (Object.getOwnPropertyNames) {
                var jt = !n(function() {
                    Object.getOwnPropertyNames("foo")
                });
                if (!jt) {
                    var Ot = Object.getOwnPropertyNames;
                    A(Object, "getOwnPropertyNames", function(t) {
                        return Ot(W.ToObject(t))
                    })
                }
            }
            if (Object.getOwnPropertyDescriptor) {
                var xt = !n(function() {
                    Object.getOwnPropertyDescriptor("foo", "bar")
                });
                if (!xt) {
                    var kt = Object.getOwnPropertyDescriptor;
                    A(Object, "getOwnPropertyDescriptor", function(t, e) {
                        return kt(W.ToObject(t), e)
                    })
                }
            }
            if (Object.seal) {
                var Tt = !n(function() {
                    Object.seal("foo")
                });
                if (!Tt) {
                    var Mt = Object.seal;
                    A(Object, "seal", function(t) {
                        return I.object(t) ? Mt(t) : t
                    })
                }
            }
            if (Object.isSealed) {
                var Et = !n(function() {
                    Object.isSealed("foo")
                });
                if (!Et) {
                    var _t = Object.isSealed;
                    A(Object, "isSealed", function(t) {
                        return !I.object(t) || _t(t)
                    })
                }
            }
            if (Object.freeze) {
                var It = !n(function() {
                    Object.freeze("foo")
                });
                if (!It) {
                    var Pt = Object.freeze;
                    A(Object, "freeze", function(t) {
                        return I.object(t) ? Pt(t) : t
                    })
                }
            }
            if (Object.isFrozen) {
                var Ct = !n(function() {
                    Object.isFrozen("foo")
                });
                if (!Ct) {
                    var Nt = Object.isFrozen;
                    A(Object, "isFrozen", function(t) {
                        return !I.object(t) || Nt(t)
                    })
                }
            }
            if (Object.preventExtensions) {
                var At = !n(function() {
                    Object.preventExtensions("foo")
                });
                if (!At) {
                    var zt = Object.preventExtensions;
                    A(Object, "preventExtensions", function(t) {
                        return I.object(t) ? zt(t) : t
                    })
                }
            }
            if (Object.isExtensible) {
                var Ft = !n(function() {
                    Object.isExtensible("foo")
                });
                if (!Ft) {
                    var Lt = Object.isExtensible;
                    A(Object, "isExtensible", function(t) {
                        return !!I.object(t) && Lt(t)
                    })
                }
            }
            if (Object.getPrototypeOf) {
                var Rt = !n(function() {
                    Object.getPrototypeOf("foo")
                });
                if (!Rt) {
                    var Wt = Object.getPrototypeOf;
                    A(Object, "getPrototypeOf", function(t) {
                        return Wt(W.ToObject(t))
                    })
                }
            }
            if (!RegExp.prototype.flags && c) {
                var Gt = function() {
                    if (!W.TypeIsObject(this)) throw new TypeError("Method called on incompatible type: must be an object.");
                    var t = "";
                    return this.global && (t += "g"), this.ignoreCase && (t += "i"), this.multiline && (t += "m"), this.unicode && (t += "u"), this.sticky && (t += "y"), t
                };
                N.getter(RegExp.prototype, "flags", Gt)
            }
            var Ht = o(function() {
                return "/a/i" === String(new RegExp(/a/g, "i"))
            });
            if (!Ht && c) {
                var Dt = RegExp,
                    $t = function Ke(t, e) {
                        var r = this instanceof Ke;
                        return r || !I.regex(t) && t.constructor !== Ke ? I.regex(t) && I.string(e) ? new Ke(t.source, e) : new Dt(t, e) : t
                    };
                N.preserveToString($t, Dt), Object.setPrototypeOf && Object.setPrototypeOf(Dt, $t), l(Object.getOwnPropertyNames(Dt), function(t) {
                    "$input" !== t && (t in M || N.proxy(Dt, t, $t))
                }), $t.prototype = Dt.prototype, N.redefine(Dt.prototype, "constructor", $t), RegExp = $t, N.redefine(S, "RegExp", $t)
            }
            if (c) {
                var Ut = {
                    input: "$_",
                    lastMatch: "$&",
                    lastParen: "$+",
                    leftContext: "$`",
                    rightContext: "$'"
                };
                l(Object.keys(Ut), function(t) {
                    t in RegExp && !(Ut[t] in RegExp) && N.getter(RegExp, Ut[t], function() {
                        return RegExp[t]
                    })
                })
            }
            var Vt = function(t) {
                    return t * t
                },
                qt = function(t, e) {
                    return t + e
                },
                Zt = 1 / Number.EPSILON,
                Xt = function(t) {
                    return t + Zt - Zt
                },
                Bt = Math.pow(2, -23),
                Jt = Math.pow(2, 127) * (2 - Bt),
                Kt = Math.pow(2, -126),
                Yt = Number.prototype.clz;
            delete Number.prototype.clz;
            var Qt = {
                acosh: function(t) {
                    var e = Number(t);
                    return Number.isNaN(e) || t < 1 ? NaN : 1 === e ? 0 : e === 1 / 0 ? e : Math.log(e / Math.E + Math.sqrt(e + 1) * Math.sqrt(e - 1) / Math.E) + 1
                },
                asinh: function(t) {
                    var e = Number(t);
                    return 0 !== e && j(e) ? e < 0 ? -Math.asinh(-e) : Math.log(e + Math.sqrt(e * e + 1)) : e
                },
                atanh: function(t) {
                    var e = Number(t);
                    return Number.isNaN(e) || e < -1 || e > 1 ? NaN : e === -1 ? -(1 / 0) : 1 === e ? 1 / 0 : 0 === e ? e : .5 * Math.log((1 + e) / (1 - e))
                },
                cbrt: function(t) {
                    var e = Number(t);
                    if (0 === e) return e;
                    var r, n = e < 0;
                    return n && (e = -e), e === 1 / 0 ? r = 1 / 0 : (r = Math.exp(Math.log(e) / 3), r = (e / (r * r) + 2 * r) / 3), n ? -r : r
                },
                clz32: function(t) {
                    var e = Number(t),
                        r = W.ToUint32(e);
                    return 0 === r ? 32 : Yt ? Yt.call(r) : 31 - Math.floor(Math.log(r + .5) * Math.LOG2E)
                },
                cosh: function(t) {
                    var e = Number(t);
                    return 0 === e ? 1 : Number.isNaN(e) ? NaN : j(e) ? (e < 0 && (e = -e), e > 21 ? Math.exp(e) / 2 : (Math.exp(e) + Math.exp(-e)) / 2) : 1 / 0
                },
                expm1: function(t) {
                    var e = Number(t);
                    if (e === -(1 / 0)) return -1;
                    if (!j(e) || 0 === e) return e;
                    if (Math.abs(e) > .5) return Math.exp(e) - 1;
                    for (var r = e, n = 0, o = 1; n + r !== n;) n += r, o += 1, r *= e / o;
                    return n
                },
                hypot: function(t, e) {
                    var r = !1,
                        n = !0,
                        o = !1,
                        i = [];
                    if (Array.prototype.every.call(arguments, function(t) {
                            var e = Number(t);
                            return Number.isNaN(e) ? r = !0 : e === 1 / 0 || e === -(1 / 0) ? o = !0 : 0 !== e && (n = !1), !o && (r || i.push(Math.abs(e)), !0)
                        }), o) return 1 / 0;
                    if (r) return NaN;
                    if (n) return 0;
                    var a = Math.max.apply(Math, i),
                        s = f(i, function(t) {
                            return t / a
                        }),
                        u = p(f(s, Vt), qt);
                    return a * Math.sqrt(u)
                },
                log2: function(t) {
                    return Math.log(t) * Math.LOG2E
                },
                log10: function(t) {
                    return Math.log(t) * Math.LOG10E
                },
                log1p: function(t) {
                    var e = Number(t);
                    return e < -1 || Number.isNaN(e) ? NaN : 0 === e || e === 1 / 0 ? e : e === -1 ? -(1 / 0) : 1 + e - 1 === 0 ? e : e * (Math.log(1 + e) / (1 + e - 1))
                },
                sign: function(t) {
                    var e = Number(t);
                    return 0 === e ? e : Number.isNaN(e) ? e : e < 0 ? -1 : 1
                },
                sinh: function(t) {
                    var e = Number(t);
                    return j(e) && 0 !== e ? Math.abs(e) < 1 ? (Math.expm1(e) - Math.expm1(-e)) / 2 : (Math.exp(e - 1) - Math.exp(-e - 1)) * Math.E / 2 : e
                },
                tanh: function(t) {
                    var e = Number(t);
                    if (Number.isNaN(e) || 0 === e) return e;
                    if (e === 1 / 0) return 1;
                    if (e === -(1 / 0)) return -1;
                    var r = Math.expm1(e),
                        n = Math.expm1(-e);
                    return r === 1 / 0 ? 1 : n === 1 / 0 ? -1 : (r - n) / (Math.exp(e) + Math.exp(-e))
                },
                trunc: function(t) {
                    var e = Number(t);
                    return e < 0 ? -Math.floor(-e) : Math.floor(e)
                },
                imul: function(t, e) {
                    var r = W.ToUint32(t),
                        n = W.ToUint32(e),
                        o = r >>> 16 & 65535,
                        i = 65535 & r,
                        a = n >>> 16 & 65535,
                        s = 65535 & n;
                    return i * s + (o * s + i * a << 16 >>> 0) | 0
                },
                fround: function(t) {
                    var e = Number(t);
                    if (0 === e || e === 1 / 0 || e === -(1 / 0) || P(e)) return e;
                    var r = Math.sign(e),
                        n = Math.abs(e);
                    if (n < Kt) return r * Xt(n / Kt / Bt) * Kt * Bt;
                    var o = (1 + Bt / Number.EPSILON) * n,
                        i = o - (o - n);
                    return i > Jt || P(i) ? r * (1 / 0) : r * i
                }
            };
            d(Math, Qt), y(Math, "log1p", Qt.log1p, Math.log1p(-1e-17) !== -1e-17), y(Math, "asinh", Qt.asinh, Math.asinh(-1e7) !== -Math.asinh(1e7)), y(Math, "tanh", Qt.tanh, Math.tanh(-2e-17) !== -2e-17), y(Math, "acosh", Qt.acosh, Math.acosh(Number.MAX_VALUE) === 1 / 0), y(Math, "cbrt", Qt.cbrt, Math.abs(1 - Math.cbrt(1e-300) / 1e-100) / Number.EPSILON > 8), y(Math, "sinh", Qt.sinh, Math.sinh(-2e-17) !== -2e-17);
            var te = Math.expm1(10);
            y(Math, "expm1", Qt.expm1, te > 22025.465794806718 || te < 22025.465794806718);
            var ee = Math.round,
                re = 0 === Math.round(.5 - Number.EPSILON / 4) && 1 === Math.round(-.5 + Number.EPSILON / 3.99),
                ne = Zt + 1,
                oe = 2 * Zt - 1,
                ie = [ne, oe].every(function(t) {
                    return Math.round(t) === t
                });
            y(Math, "round", function(t) {
                var e = Math.floor(t),
                    r = e === -1 ? -0 : e + 1;
                return t - e < .5 ? e : r
            }, !re || !ie), N.preserveToString(Math.round, ee);
            var ae = Math.imul;
            Math.imul(4294967295, 5) !== -5 && (Math.imul = Qt.imul, N.preserveToString(Math.imul, ae)), 2 !== Math.imul.length && A(Math, "imul", function(t, e) {
                return ae.apply(Math, arguments)
            });
            var se = function() {
                var t, e;
                W.IsPromise = function(t) {
                    return !!W.TypeIsObject(t) && (!!t._promiseConstructor && "undefined" != typeof t._status)
                };
                var r, n = function(t) {
                        if (!W.IsCallable(t)) throw new TypeError("bad promise constructor");
                        var e = this,
                            r = function(t, r) {
                                e.resolve = t, e.reject = r
                            };
                        if (e.promise = W.Construct(t, [r]), !e.promise._es6construct) throw new TypeError("bad promise constructor");
                        if (!W.IsCallable(e.resolve) || !W.IsCallable(e.reject)) throw new TypeError("bad promise constructor")
                    },
                    o = S.setTimeout;
                "undefined" != typeof window && W.IsCallable(window.postMessage) && (r = function() {
                    var t = [],
                        e = "zero-timeout-message",
                        r = function(r) {
                            t.push(r), window.postMessage(e, "*")
                        },
                        n = function(r) {
                            if (r.source === window && r.data === e) {
                                if (r.stopPropagation(), 0 === t.length) return;
                                var n = t.shift();
                                n()
                            }
                        };
                    return window.addEventListener("message", n, !0), r
                });
                var s = function() {
                        var t = S.Promise;
                        return t && t.resolve && function(e) {
                            return t.resolve().then(e)
                        }
                    },
                    u = W.IsCallable(S.setImmediate) ? S.setImmediate.bind(S) : "object" === ("undefined" == typeof i ? "undefined" : a(i)) && i.nextTick ? i.nextTick : s() || (W.IsCallable(r) ? r() : function(t) {
                        o(t, 0)
                    }),
                    c = function(t, e) {
                        if (!W.TypeIsObject(t)) return !1;
                        var r = e.resolve,
                            n = e.reject;
                        try {
                            var o = t.then;
                            if (!W.IsCallable(o)) return !1;
                            o.call(t, r, n)
                        } catch (i) {
                            n(i)
                        }
                        return !0
                    },
                    f = function(t, e) {
                        l(t, function(t) {
                            u(function() {
                                var r = t.handler,
                                    n = t.capability,
                                    o = n.resolve,
                                    i = n.reject;
                                try {
                                    var a = r(e);
                                    if (a === n.promise) throw new TypeError("self resolution");
                                    var s = c(a, n);
                                    s || o(a)
                                } catch (u) {
                                    i(u)
                                }
                            })
                        })
                    },
                    p = function(t, e, r) {
                        return function(o) {
                            if (o === t) return r(new TypeError("self resolution"));
                            var i = t._promiseConstructor,
                                a = new n(i),
                                s = c(o, a);
                            return s ? a.promise.then(e, r) : e(o)
                        }
                    };
                t = function(t) {
                    var e = this;
                    if (e = G(e), !e._promiseConstructor) throw new TypeError("bad promise");
                    if ("undefined" != typeof e._status) throw new TypeError("promise already initialized");
                    if (!W.IsCallable(t)) throw new TypeError("not a valid resolver");
                    e._status = "unresolved", e._resolveReactions = [], e._rejectReactions = [];
                    var r = function(t) {
                            if ("unresolved" === e._status) {
                                var r = e._resolveReactions;
                                e._result = t, e._resolveReactions = void 0, e._rejectReactions = void 0, e._status = "has-resolution", f(r, t)
                            }
                        },
                        n = function(t) {
                            if ("unresolved" === e._status) {
                                var r = e._rejectReactions;
                                e._result = t, e._resolveReactions = void 0, e._rejectReactions = void 0, e._status = "has-rejection", f(r, t)
                            }
                        };
                    try {
                        t(r, n)
                    } catch (o) {
                        n(o)
                    }
                    return e
                }, e = t.prototype;
                var h = function(t, e, r, n) {
                    var o = !1;
                    return function(i) {
                        if (!o && (o = !0, e[t] = i, 0 === --n.count)) {
                            var a = r.resolve;
                            a(e)
                        }
                    }
                };
                y(t, _, function(t) {
                    var r = this,
                        n = r.prototype || e,
                        o = t || v(n);
                    return d(o, {
                        _status: void 0,
                        _result: void 0,
                        _resolveReactions: void 0,
                        _rejectReactions: void 0,
                        _promiseConstructor: void 0
                    }), o._promiseConstructor = r, o
                }), d(t, {
                    all: function(t) {
                        var e = this,
                            r = new n(e),
                            o = r.resolve,
                            i = r.reject;
                        try {
                            if (!W.IsIterable(t)) throw new TypeError("bad iterable");
                            for (var a = W.GetIterator(t), s = [], u = {
                                    count: 1
                                }, c = 0;; c++) {
                                var l = W.IteratorNext(a);
                                if (l.done) break;
                                var f = e.resolve(l.value),
                                    p = h(c, s, r, u);
                                u.count++, f.then(p, r.reject)
                            }
                            0 === --u.count && o(s)
                        } catch (y) {
                            i(y)
                        }
                        return r.promise
                    },
                    race: function(t) {
                        var e = this,
                            r = new n(e),
                            o = r.resolve,
                            i = r.reject;
                        try {
                            if (!W.IsIterable(t)) throw new TypeError("bad iterable");
                            for (var a = W.GetIterator(t);;) {
                                var s = W.IteratorNext(a);
                                if (s.done) break;
                                var u = e.resolve(s.value);
                                u.then(o, i)
                            }
                        } catch (c) {
                            i(c)
                        }
                        return r.promise
                    },
                    reject: function(t) {
                        var e = this,
                            r = new n(e),
                            o = r.reject;
                        return o(t), r.promise
                    },
                    resolve: function(t) {
                        var e = this;
                        if (W.IsPromise(t)) {
                            var r = t._promiseConstructor;
                            if (r === e) return t
                        }
                        var o = new n(e),
                            i = o.resolve;
                        return i(t), o.promise
                    }
                });
                var b = function(t) {
                        return t
                    },
                    g = function(t) {
                        throw t
                    };
                return d(e, {
                    "catch": function(t) {
                        return this.then(void 0, t)
                    },
                    then: function(t, e) {
                        var r = this;
                        if (!W.IsPromise(r)) throw new TypeError("not a promise");
                        var o = this.constructor,
                            i = new n(o);
                        W.IsCallable(e) || (e = g), W.IsCallable(t) || (t = b);
                        var a = p(r, t, e),
                            s = {
                                capability: i,
                                handler: a
                            },
                            u = {
                                capability: i,
                                handler: e
                            };
                        switch (r._status) {
                            case "unresolved":
                                r._resolveReactions.push(s), r._rejectReactions.push(u);
                                break;
                            case "has-resolution":
                                f([s], r._result);
                                break;
                            case "has-rejection":
                                f([u], r._result);
                                break;
                            default:
                                throw new TypeError("unexpected")
                        }
                        return i.promise
                    }
                }), t
            }();
            S.Promise && (delete S.Promise.accept, delete S.Promise.defer, delete S.Promise.prototype.chain), d(S, {
                Promise: se
            });
            var ue = b(S.Promise, function(t) {
                    return t.resolve(42) instanceof t
                }),
                ce = !n(function() {
                    S.Promise.reject(42).then(null, 5).then(null, M)
                }),
                le = n(function() {
                    S.Promise.call(3, M)
                });
            ue && ce && le || (Promise = se, A(S, "Promise", se));
            var fe = function(t) {
                    var e = Object.keys(p(t, function(t, e) {
                        return t[e] = !0, t
                    }, {}));
                    return t.join(":") === e.join(":")
                },
                pe = fe(["z", "a", "bb"]),
                he = fe(["z", 1, "a", "3", 2]);
            if (c) {
                var ye = function(t) {
                        if (!pe) return null;
                        var e = "undefined" == typeof t ? "undefined" : a(t);
                        return "string" === e ? "$" + t : "number" === e ? he ? t : "n" + t : null
                    },
                    de = function() {
                        return Object.create ? Object.create(null) : {}
                    },
                    ve = {
                        Map: function() {
                            function t(t, e) {
                                this.key = t, this.value = e, this.next = null, this.prev = null
                            }

                            function e(t, e) {
                                i(t, "[[MapIterator]]"), this.head = t._head, this.i = this.head, this.kind = e
                            }

                            function r() {
                                var e = this;
                                if (!W.TypeIsObject(e)) throw new TypeError("Constructor Map requires 'new'");
                                if (e = G(e), !e._es6map) throw new TypeError("bad map");
                                var r = new t(null, null);
                                if (r.next = r.prev = r, d(e, {
                                        _head: r,
                                        _storage: de(),
                                        _size: 0
                                    }), arguments.length > 0 && "undefined" != typeof arguments[0] && null !== arguments[0]) {
                                    var n = W.GetIterator(arguments[0]),
                                        o = e.set;
                                    if (!W.IsCallable(o)) throw new TypeError("bad map");
                                    for (;;) {
                                        var i = W.IteratorNext(n);
                                        if (i.done) break;
                                        var a = i.value;
                                        if (!W.TypeIsObject(a)) throw new TypeError("expected iterable of pairs");
                                        o.call(e, a[0], a[1])
                                    }
                                }
                                return e
                            }
                            var n = {};
                            t.prototype.isRemoved = function() {
                                return this.key === n
                            };
                            var o = function(t) {
                                    return !!t._es6map
                                },
                                i = function(t, e) {
                                    if (!W.TypeIsObject(t) || !o(t)) throw new TypeError("Method Map.prototype." + e + " called on incompatible receiver " + String(t))
                                };
                            e.prototype = {
                                next: function() {
                                    var t, e = this.i,
                                        r = this.kind,
                                        n = this.head;
                                    if ("undefined" == typeof this.i) return {
                                        value: void 0,
                                        done: !0
                                    };
                                    for (; e.isRemoved() && e !== n;) e = e.prev;
                                    for (; e.next !== n;)
                                        if (e = e.next, !e.isRemoved()) return t = "key" === r ? e.key : "value" === r ? e.value : [e.key, e.value], this.i = e, {
                                            value: t,
                                            done: !1
                                        };
                                    return this.i = void 0, {
                                        value: void 0,
                                        done: !0
                                    }
                                }
                            }, F(e.prototype);
                            var a = r.prototype;
                            return y(r, _, function(t) {
                                var e = this,
                                    r = e.prototype || a,
                                    n = t || v(r);
                                return d(n, {
                                    _es6map: !0
                                }), n
                            }), N.getter(r.prototype, "size", function() {
                                if ("undefined" == typeof this._size) throw new TypeError("size method called on incompatible Map");
                                return this._size
                            }), d(r.prototype, {
                                get: function(t) {
                                    i(this, "get");
                                    var e = ye(t);
                                    if (null !== e) {
                                        var r = this._storage[e];
                                        return r ? r.value : void 0
                                    }
                                    for (var n = this._head, o = n;
                                        (o = o.next) !== n;)
                                        if (W.SameValueZero(o.key, t)) return o.value
                                },
                                has: function(t) {
                                    i(this, "has");
                                    var e = ye(t);
                                    if (null !== e) return "undefined" != typeof this._storage[e];
                                    for (var r = this._head, n = r;
                                        (n = n.next) !== r;)
                                        if (W.SameValueZero(n.key, t)) return !0;
                                    return !1
                                },
                                set: function(e, r) {
                                    i(this, "set");
                                    var n, o = this._head,
                                        a = o,
                                        s = ye(e);
                                    if (null !== s) {
                                        if ("undefined" != typeof this._storage[s]) return this._storage[s].value = r, this;
                                        n = this._storage[s] = new t(e, r), a = o.prev
                                    }
                                    for (;
                                        (a = a.next) !== o;)
                                        if (W.SameValueZero(a.key, e)) return a.value = r, this;
                                    return n = n || new t(e, r), W.SameValue(-0, e) && (n.key = 0), n.next = this._head, n.prev = this._head.prev, n.prev.next = n, n.next.prev = n, this._size += 1, this
                                },
                                "delete": function(t) {
                                    i(this, "delete");
                                    var e = this._head,
                                        r = e,
                                        o = ye(t);
                                    if (null !== o) {
                                        if ("undefined" == typeof this._storage[o]) return !1;
                                        r = this._storage[o].prev, delete this._storage[o]
                                    }
                                    for (;
                                        (r = r.next) !== e;)
                                        if (W.SameValueZero(r.key, t)) return r.key = r.value = n, r.prev.next = r.next, r.next.prev = r.prev, this._size -= 1, !0;
                                    return !1
                                },
                                clear: function() {
                                    i(this, "clear"), this._size = 0, this._storage = de();
                                    for (var t = this._head, e = t, r = e.next;
                                        (e = r) !== t;) e.key = e.value = n, r = e.next, e.next = e.prev = t;
                                    t.next = t.prev = t
                                },
                                keys: function() {
                                    return i(this, "keys"), new e(this, "key")
                                },
                                values: function() {
                                    return i(this, "values"), new e(this, "value")
                                },
                                entries: function() {
                                    return i(this, "entries"), new e(this, "key+value")
                                },
                                forEach: function(t) {
                                    i(this, "forEach");
                                    for (var e = arguments.length > 1 ? arguments[1] : null, r = this.entries(), n = r.next(); !n.done; n = r.next()) e ? t.call(e, n.value[1], n.value[0], this) : t(n.value[1], n.value[0], this)
                                }
                            }), F(r.prototype, function() {
                                return this.entries()
                            }), r
                        }(),
                        Set: function() {
                            var t = function(t) {
                                    return t._es6set && "undefined" != typeof t._storage
                                },
                                e = function(e, r) {
                                    if (!W.TypeIsObject(e) || !t(e)) throw new TypeError("Set.prototype." + r + " called on incompatible receiver " + String(e))
                                },
                                r = function() {
                                    var t = this;
                                    if (!W.TypeIsObject(t)) throw new TypeError("Constructor Set requires 'new'");
                                    if (t = G(t), !t._es6set) throw new TypeError("bad set");
                                    if (d(t, {
                                            "[[SetData]]": null,
                                            _storage: de()
                                        }), arguments.length > 0 && "undefined" != typeof arguments[0] && null !== arguments[0]) {
                                        var e = arguments[0],
                                            r = W.GetIterator(e),
                                            n = t.add;
                                        if (!W.IsCallable(n)) throw new TypeError("bad set");
                                        for (;;) {
                                            var o = W.IteratorNext(r);
                                            if (o.done) break;
                                            var i = o.value;
                                            n.call(t, i)
                                        }
                                    }
                                    return t
                                },
                                n = r.prototype;
                            y(r, _, function(t) {
                                var e = this,
                                    r = e.prototype || n,
                                    o = t || v(r);
                                return d(o, {
                                    _es6set: !0
                                }), o
                            });
                            var o = function(t) {
                                if (!t["[[SetData]]"]) {
                                    var e = t["[[SetData]]"] = new ve.Map;
                                    l(Object.keys(t._storage), function(t) {
                                        t = 36 === t.charCodeAt(0) ? t.slice(1) : "n" === t.charAt(0) ? +t.slice(1) : +t, e.set(t, t)
                                    }), t._storage = null
                                }
                            };
                            return N.getter(r.prototype, "size", function() {
                                return e(this, "size"), o(this), this["[[SetData]]"].size
                            }), d(r.prototype, {
                                has: function(t) {
                                    e(this, "has");
                                    var r;
                                    return this._storage && null !== (r = ye(t)) ? !!this._storage[r] : (o(this), this["[[SetData]]"].has(t))
                                },
                                add: function(t) {
                                    e(this, "add");
                                    var r;
                                    return this._storage && null !== (r = ye(t)) ? (this._storage[r] = !0, this) : (o(this), this["[[SetData]]"].set(t, t), this)
                                },
                                "delete": function(t) {
                                    e(this, "delete");
                                    var r;
                                    if (this._storage && null !== (r = ye(t))) {
                                        var n = T(this._storage, r);
                                        return delete this._storage[r] && n
                                    }
                                    return o(this), this["[[SetData]]"]["delete"](t)
                                },
                                clear: function() {
                                    e(this, "clear"), this._storage ? this._storage = de() : this["[[SetData]]"].clear();
                                },
                                values: function() {
                                    return e(this, "values"), o(this), this["[[SetData]]"].values()
                                },
                                entries: function() {
                                    return e(this, "entries"), o(this), this["[[SetData]]"].entries()
                                },
                                forEach: function(t) {
                                    e(this, "forEach");
                                    var r = arguments.length > 1 ? arguments[1] : null,
                                        n = this;
                                    o(n), this["[[SetData]]"].forEach(function(e, o) {
                                        r ? t.call(r, o, o, n) : t(o, o, n)
                                    })
                                }
                            }), y(r, "keys", r.values, !0), F(r.prototype, function() {
                                return this.values()
                            }), r
                        }()
                    };
                if (d(S, ve), S.Map || S.Set) {
                    var be = o(function() {
                        return 2 === new Map([
                            [1, 2]
                        ]).get(1)
                    });
                    if (!be) {
                        var ge = S.Map;
                        S.Map = function Ye() {
                            if (!(this instanceof Ye)) throw new TypeError('Constructor Map requires "new"');
                            var t, e = new ge;
                            return arguments.length > 0 && (t = arguments[0]), Array.isArray(t) || I.string(t) ? l(t, function(t) {
                                e.set(t[0], t[1])
                            }) : t instanceof Ye && Ye.prototype.forEach.call(t, function(t, r) {
                                e.set(r, t)
                            }), Object.setPrototypeOf(e, S.Map.prototype), y(e, "constructor", Ye, !0), e
                        }, S.Map.prototype = v(ge.prototype), N.preserveToString(S.Map, ge)
                    }
                    var me = new Map,
                        we = function(t) {
                            return t["delete"](0), t["delete"](-0), t.set(0, 3), t.get(-0, 4), 3 === t.get(0) && 4 === t.get(-0)
                        }(me),
                        Se = me.set(1, 2) === me;
                    if (!we || !Se) {
                        var je = Map.prototype.set;
                        A(Map.prototype, "set", function(t, e) {
                            return je.call(this, 0 === t ? 0 : t, e), this
                        })
                    }
                    if (!we) {
                        var Oe = Map.prototype.get,
                            xe = Map.prototype.has;
                        d(Map.prototype, {
                            get: function(t) {
                                return Oe.call(this, 0 === t ? 0 : t)
                            },
                            has: function(t) {
                                return xe.call(this, 0 === t ? 0 : t)
                            }
                        }, !0), N.preserveToString(Map.prototype.get, Oe), N.preserveToString(Map.prototype.has, xe)
                    }
                    var ke = new Set,
                        Te = function(t) {
                            return t["delete"](0), t.add(-0), !t.has(0)
                        }(ke),
                        Me = ke.add(1) === ke;
                    if (!Te || !Me) {
                        var Ee = Set.prototype.add;
                        Set.prototype.add = function(t) {
                            return Ee.call(this, 0 === t ? 0 : t), this
                        }, N.preserveToString(Set.prototype.add, Ee)
                    }
                    if (!Te) {
                        var _e = Set.prototype.has;
                        Set.prototype.has = function(t) {
                            return _e.call(this, 0 === t ? 0 : t)
                        }, N.preserveToString(Set.prototype.has, _e);
                        var Ie = Set.prototype["delete"];
                        Set.prototype["delete"] = function(t) {
                            return Ie.call(this, 0 === t ? 0 : t)
                        }, N.preserveToString(Set.prototype["delete"], Ie)
                    }
                    var Pe = b(S.Map, function(t) {
                            var e = new t([]);
                            return e.set(42, 42), e instanceof t
                        }),
                        Ce = Object.setPrototypeOf && !Pe,
                        Ne = function() {
                            try {
                                return !(S.Map() instanceof S.Map)
                            } catch (t) {
                                return t instanceof TypeError
                            }
                        }();
                    if (0 !== S.Map.length || Ce || !Ne) {
                        var Ae = S.Map;
                        S.Map = function Qe() {
                            if (!(this instanceof Qe)) throw new TypeError('Constructor Map requires "new"');
                            var t = arguments.length > 0 ? new Ae(arguments[0]) : new Ae;
                            return Object.setPrototypeOf(t, Qe.prototype), y(t, "constructor", Qe, !0), t
                        }, S.Map.prototype = Ae.prototype, N.preserveToString(S.Map, Ae)
                    }
                    var ze = b(S.Set, function(t) {
                            var e = new t([]);
                            return e.add(42, 42), e instanceof t
                        }),
                        Fe = Object.setPrototypeOf && !ze,
                        Le = function() {
                            try {
                                return !(S.Set() instanceof S.Set)
                            } catch (t) {
                                return t instanceof TypeError
                            }
                        }();
                    if (0 !== S.Set.length || Fe || !Le) {
                        var Re = S.Set;
                        S.Set = function tr() {
                            if (!(this instanceof tr)) throw new TypeError('Constructor Set requires "new"');
                            var t = arguments.length > 0 ? new Re(arguments[0]) : new Re;
                            return Object.setPrototypeOf(t, tr.prototype), y(t, "constructor", tr, !0), t
                        }, S.Set.prototype = Re.prototype, N.preserveToString(S.Set, Re)
                    }
                    var We = !o(function() {
                        return (new Map).keys().next().done
                    });
                    ("function" != typeof S.Map.prototype.clear || 0 !== (new S.Set).size || 0 !== (new S.Map).size || "function" != typeof S.Map.prototype.keys || "function" != typeof S.Set.prototype.keys || "function" != typeof S.Map.prototype.forEach || "function" != typeof S.Set.prototype.forEach || s(S.Map) || s(S.Set) || "function" != typeof(new S.Map).keys().next || We || !Pe) && (delete S.Map, delete S.Set, d(S, {
                        Map: ve.Map,
                        Set: ve.Set
                    }, !0))
                }
                S.Set.prototype.keys !== S.Set.prototype.values && y(S.Set.prototype, "keys", S.Set.prototype.values, !0), F(Object.getPrototypeOf((new S.Map).keys())), F(Object.getPrototypeOf((new S.Set).keys()))
            }
            S.Reflect || y(S, "Reflect", {});
            var Ge = S.Reflect,
                He = function(t) {
                    if (!W.TypeIsObject(t)) throw new TypeError("target must be an object")
                };
            d(S.Reflect, {
                apply: function() {
                    return W.Call.apply(null, arguments)
                },
                construct: function(t, e) {
                    if (!W.IsCallable(t)) throw new TypeError("First argument must be callable.");
                    return W.Construct(t, e)
                },
                deleteProperty: function(t, e) {
                    if (He(t), c) {
                        var r = Object.getOwnPropertyDescriptor(t, e);
                        if (r && !r.configurable) return !1
                    }
                    return delete t[e]
                },
                enumerate: function(t) {
                    return He(t), new Y(t, "key")
                },
                has: function(t, e) {
                    return He(t), e in t
                }
            }), Object.getOwnPropertyNames && d(S.Reflect, {
                ownKeys: function(t) {
                    He(t);
                    var e = Object.getOwnPropertyNames(t);
                    return W.IsCallable(Object.getOwnPropertySymbols) && e.push.apply(e, Object.getOwnPropertySymbols(t)), e
                }
            });
            var De = function(t) {
                return !n(t)
            };
            if (Object.preventExtensions && d(S.Reflect, {
                    isExtensible: function(t) {
                        return He(t), Object.isExtensible(t)
                    },
                    preventExtensions: function(t) {
                        return He(t), De(function() {
                            Object.preventExtensions(t)
                        })
                    }
                }), c) {
                var $e = function(t, e, r) {
                        var n = Object.getOwnPropertyDescriptor(t, e);
                        if (!n) {
                            var o = Object.getPrototypeOf(t);
                            if (null === o) return;
                            return $e(o, e, r)
                        }
                        return "value" in n ? n.value : n.get ? n.get.call(r) : void 0
                    },
                    Ue = function(t, e, r, n) {
                        var o = Object.getOwnPropertyDescriptor(t, e);
                        if (!o) {
                            var i = Object.getPrototypeOf(t);
                            if (null !== i) return Ue(i, e, r, n);
                            o = {
                                value: void 0,
                                writable: !0,
                                enumerable: !0,
                                configurable: !0
                            }
                        }
                        if ("value" in o) {
                            if (!o.writable) return !1;
                            if (!W.TypeIsObject(n)) return !1;
                            var a = Object.getOwnPropertyDescriptor(n, e);
                            return a ? Ge.defineProperty(n, e, {
                                value: r
                            }) : Ge.defineProperty(n, e, {
                                value: r,
                                writable: !0,
                                enumerable: !0,
                                configurable: !0
                            })
                        }
                        return !!o.set && (o.set.call(n, r), !0)
                    };
                d(S.Reflect, {
                    defineProperty: function(t, e, r) {
                        return He(t), De(function() {
                            Object.defineProperty(t, e, r)
                        })
                    },
                    getOwnPropertyDescriptor: function(t, e) {
                        return He(t), Object.getOwnPropertyDescriptor(t, e)
                    },
                    get: function(t, e) {
                        He(t);
                        var r = arguments.length > 2 ? arguments[2] : t;
                        return $e(t, e, r)
                    },
                    set: function(t, e, r) {
                        He(t);
                        var n = arguments.length > 3 ? arguments[3] : t;
                        return Ue(t, e, r, n)
                    }
                })
            }
            if (Object.getPrototypeOf) {
                var Ve = Object.getPrototypeOf;
                d(S.Reflect, {
                    getPrototypeOf: function(t) {
                        return He(t), Ve(t)
                    }
                })
            }
            if (Object.setPrototypeOf) {
                var qe = function(t, e) {
                    for (; e;) {
                        if (t === e) return !0;
                        e = Ge.getPrototypeOf(e)
                    }
                    return !1
                };
                d(S.Reflect, {
                    setPrototypeOf: function(t, e) {
                        if (He(t), null !== e && !W.TypeIsObject(e)) throw new TypeError("proto must be an object or null");
                        return e === Ge.getPrototypeOf(t) || !(Ge.isExtensible && !Ge.isExtensible(t)) && (!qe(t, e) && (Object.setPrototypeOf(t, e), !0))
                    }
                })
            }
            if ("Invalid Date" !== String(new Date(NaN))) {
                var Ze = Date.prototype.toString,
                    Xe = function() {
                        var t = +this;
                        return t !== t ? "Invalid Date" : Ze.call(this)
                    };
                A(Date.prototype, "toString", Xe)
            }
            var Be = {
                anchor: function(t) {
                    return W.CreateHTML(this, "a", "name", t)
                },
                big: function() {
                    return W.CreateHTML(this, "big", "", "")
                },
                blink: function() {
                    return W.CreateHTML(this, "blink", "", "")
                },
                bold: function() {
                    return W.CreateHTML(this, "b", "", "")
                },
                fixed: function() {
                    return W.CreateHTML(this, "tt", "", "")
                },
                fontcolor: function(t) {
                    return W.CreateHTML(this, "font", "color", t)
                },
                fontsize: function(t) {
                    return W.CreateHTML(this, "font", "size", t)
                },
                italics: function() {
                    return W.CreateHTML(this, "i", "", "")
                },
                link: function(t) {
                    return W.CreateHTML(this, "a", "href", t)
                },
                small: function() {
                    return W.CreateHTML(this, "small", "", "")
                },
                strike: function() {
                    return W.CreateHTML(this, "strike", "", "")
                },
                sub: function() {
                    return W.CreateHTML(this, "sub", "", "")
                },
                sup: function() {
                    return W.CreateHTML(this, "sup", "", "")
                }
            };
            return d(String.prototype, Be), l(Object.keys(Be), function(t) {
                var e = String.prototype[t],
                    r = !1;
                if (W.IsCallable(e)) {
                    var n = e.call("", ' " '),
                        o = [].concat(n.match(/"/g)).length;
                    r = n !== n.toLowerCase() || o > 2
                } else r = !0;
                r && y(String.prototype, t, Be[t], !0)
            }), S
        })
    }).call(e, r(2))
}, function(t, e) {
    function r(t) {
        if (u === setTimeout) return setTimeout(t, 0);
        try {
            return u(t, 0)
        } catch (e) {
            try {
                return u.call(null, t, 0)
            } catch (e) {
                return u.call(this, t, 0)
            }
        }
    }

    function n(t) {
        if (c === clearTimeout) return clearTimeout(t);
        try {
            return c(t)
        } catch (e) {
            try {
                return c.call(null, t)
            } catch (e) {
                return c.call(this, t)
            }
        }
    }

    function o() {
        h && f && (h = !1, f.length ? p = f.concat(p) : y = -1, p.length && i())
    }

    function i() {
        if (!h) {
            var t = r(o);
            h = !0;
            for (var e = p.length; e;) {
                for (f = p, p = []; ++y < e;) f && f[y].run();
                y = -1, e = p.length
            }
            f = null, h = !1, n(t)
        }
    }

    function a(t, e) {
        this.fun = t, this.array = e
    }

    function s() {}
    var u, c, l = t.exports = {};
    ! function() {
        try {
            u = setTimeout
        } catch (t) {
            u = function() {
                throw new Error("setTimeout is not defined")
            }
        }
        try {
            c = clearTimeout
        } catch (t) {
            c = function() {
                throw new Error("clearTimeout is not defined")
            }
        }
    }();
    var f, p = [],
        h = !1,
        y = -1;
    l.nextTick = function(t) {
        var e = new Array(arguments.length - 1);
        if (arguments.length > 1)
            for (var n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
        p.push(new a(t, e)), 1 !== p.length || h || r(i)
    }, a.prototype.run = function() {
        this.fun.apply(null, this.array)
    }, l.title = "browser", l.browser = !0, l.env = {}, l.argv = [], l.version = "", l.versions = {}, l.on = s, l.addListener = s, l.once = s, l.off = s, l.removeListener = s, l.removeAllListeners = s, l.emit = s, l.binding = function(t) {
        throw new Error("process.binding is not supported")
    }, l.cwd = function() {
        return "/"
    }, l.chdir = function(t) {
        throw new Error("process.chdir is not supported")
    }, l.umask = function() {
        return 0
    }
}, function(t, e, r) {
    "use strict";
    var n = r(4),
        o = r(5),
        i = r(7),
        a = r(8),
        s = r(10),
        u = r(11),
        c = {
            black: "#000000",
            darkGray: "#222021",
            red: "#8f3036",
            white: "#fff",
            green: "#666843",
          pink: "#c60094",
          blue: "#3aa2bf",
          lightwhite:"#e9effb",
        },
        l = !0,
        f = {
            "jersey-replica-home-white": [{
                type: "text",
                fontFamily: "UnitedSansCond",
                fontSize: 75,
                x: 750,
                y: 600,
                fillStyle: c.black,
                radius: 400,
                letterSpacing: .029
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 120,
                align: "right",
                respectAlign: !0,
                x: 340,
                y: 330,
                fillStyle: c.red,
                strokeStyle: c.darkGray,
                strokeWidth: 1,
                outerStroke: {
                    color: c.darkGray,
                    width: 2
                }
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 280,
                x: 750,
                y: 380,
                fillStyle: c.red,
                strokeStyle: c.darkGray,
                strokeWidth: 2,
                outerStroke: {
                    color: c.darkGray,
                    width: 5
                }
            }],
            "jersey-replica-miami-red": [{
                type: "text",
                fontFamily: "UnitedSansCond",
                fontSize: 60,
                x: 740,
                y: 600,
                fillStyle: c.white,
                radius: 400,
                letterSpacing: .027
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 100,
                align: "right",
                respectAlign: !0,
                x: 370,
                y: 310,
                fillStyle: c.white,
                strokeStyle: c.darkGray,
                strokeWidth: 1,
                outerStroke: {
                    color: c.darkGray,
                    width: 2
                }
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 300,
                x: 750,
                y: 400,
                fillStyle: c.white,
                strokeStyle: c.darkGray,
                strokeWidth: 2,
                outerStroke: {
                    color: c.darkGray,
                    width: 3
                }
            }],
            "jersey-replica-miami-black": [{
                type: "text",
                fontFamily: "UnitedSansCond",
                fontSize: 75,
                x: 750,
                y: 600,
                fillStyle: c.white,
                radius: 400,
                letterSpacing: .029
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 100,
                align: "right",
                respectAlign: !0,
                x: 360,
                y: 320,
                fillStyle: c.white,
                strokeStyle: c.red,
                strokeWidth: 1,
                outerStroke: {
                    color: c.red,
                    width: 2
                }
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 280,
                x: 750,
                y: 390,
                fillStyle: c.white,
                strokeStyle: c.red,
                strokeWidth: 2,
                outerStroke: {
                    color: c.red,
                    width: 5
                }
            }],
            "jersey-swingman-home-white": [{
                type: "text",
                fontFamily: "UnitedSansCond",
                fontSize: 75,
                x: 750,
                y: 600,
                fillStyle: c.black,
                radius: 400,
                letterSpacing: .029
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 100,
                align: "right",
                respectAlign: !0,
                x: 340,
                y: 385,
                fillStyle: c.red,
                strokeStyle: c.darkGray,
                strokeWidth: 1,
                outerStroke: {
                    color: c.darkGray,
                    width: 2
                }
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 300,
                x: 750,
                y: 410,
                fillStyle: c.red,
                strokeStyle: c.darkGray,
                strokeWidth: 2,
                outerStroke: {
                    color: c.darkGray,
                    width: 4
                }
            }],
            "jersey-swingman-miami-red": [{
                type: "text",
                fontFamily: "UnitedSansCond",
                fontSize: 75,
                x: 750,
                y: 600,
                fillStyle: c.white,
                radius: 400,
                letterSpacing: .029
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 110,
                align: "right",
                respectAlign: !0,
                x: 370,
                y: 420,
                fillStyle: c.white,
                strokeStyle: c.darkGray,
                strokeWidth: 2,
                outerStroke: {
                    color: c.darkGray,
                    width: 2
                }
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 300,
                x: 750,
                y: 410,
                fillStyle: c.white,
                strokeStyle: c.darkGray,
                strokeWidth: 2,
                outerStroke: {
                    color: c.darkGray,
                    width: 3
                }
            }],
          	"jersey-swingman-vice-black": [{
                type: "text",
                fontFamily: "UnitedSansCond",
                fontSize: 70,
                x: 780,
                y: 520,
                fillStyle: c.white,
                radius: 300,
                letterSpacing: .035
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 100,
                x: 350,
                y: 450,
                fillStyle: c.black,
              	strokeWidth: 2,
                outerStroke: {
                    color: c.blue,
                    width: 3
                }
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 100,
                x: 347,
                y: 447,
                fillStyle: c.pink
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 210,
                x: 755,
                y: 390,
                fillStyle: c.black,
              	strokeWidth: 3,
                outerStroke: {
                    color: c.blue,
                    width: 4
                }
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 210,
                x: 750,
                y: 385,
                fillStyle: c.pink
            }],
          	"jersey-vicewave": [{
                type: "text",
                fontFamily: "UnitedSansCond",
                fontSize: 65,
                x: 760,
                y: 540,
                fillStyle: c.white,
                radius: 300,
                letterSpacing: .035
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 100,
                x: 350,
                y: 450,
                fillStyle: c.black,
              	strokeWidth: 2,
                outerStroke: {
                    color: c.lightwhite,
                    width: 3
                }
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 100,
                x: 347,
                y: 447,
                fillStyle: c.pink
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 210,
                x: 755,
                y: 390,
                fillStyle: c.black,
              	strokeWidth: 3,
                outerStroke: {
                    color: c.lightwhite,
                    width: 4
                }
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 210,
                x: 750,
                y: 385,
                fillStyle: c.pink
            }],
          	"jersey-swingman-vicewave": [{
                type: "text",
                fontFamily: "UnitedSansCond",
                fontSize: 65,
                x: 760,
                y: 540,
                fillStyle: c.darkGray,
                radius: 300,
                letterSpacing: .035
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 100,
                x: 350,
                y: 450,
                fillStyle: c.black,
              	strokeWidth: 2,
                outerStroke: {
                    color: c.lightwhite,
                    width: 3
                }
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 100,
                x: 347,
                y: 447,
                fillStyle: c.pink
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 210,
                x: 755,
                y: 390,
                fillStyle: c.black,
              	strokeWidth: 3,
                outerStroke: {
                    color: c.lightwhite,
                    width: 4
                }
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 210,
                x: 750,
                y: 385,
                fillStyle: c.pink
            }],
            "jersey-swingman-miami-black": [{
                type: "text",
                fontFamily: "UnitedSansCond",
                fontSize: 75,
                x: 750,
                y: 600,
                fillStyle: c.white,
                radius: 400,
                letterSpacing: .029
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 100,
                align: "right",
                respectAlign: !0,
                x: 365,
                y: 390,
                fillStyle: c.white,
                strokeStyle: c.red,
                strokeWidth: 1,
                outerStroke: {
                    color: c.red,
                    width: 2
                }
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 300,
                x: 750,
                y: 410,
                fillStyle: c.white,
                strokeStyle: c.red,
                strokeWidth: 3,
                outerStroke: {
                    color: c.red,
                    width: 3
                }
            }],
            "jersey-swingman-elheat-white": [{
                type: "text",
                fontFamily: "UnitedSansCond",
                fontSize: 75,
                x: 750,
                y: 620,
                fillStyle: c.black,
                radius: 400,
                letterSpacing: .029
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 90,
                align: "right",
                respectAlign: !0,
                x: 370,
                y: 350,
                fillStyle: c.red,
                strokeStyle: c.darkGray,
                strokeWidth: 1,
                outerStroke: {
                    color: c.darkGray,
                    width: 2
                }
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 300,
                x: 750,
                y: 410,
                fillStyle: c.red,
                strokeStyle: c.darkGray,
                strokeWidth: 2,
                outerStroke: {
                    color: c.darkGray,
                    width: 3
                }
            }],
            "jersey-swingman-elheat-red": [{
                type: "text",
                fontFamily: "UnitedSansCond",
                fontSize: 75,
                x: 750,
                y: 620,
                fillStyle: c.white,
                radius: 400,
                letterSpacing: .029
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 100,
                align: "right",
                respectAlign: !0,
                x: 365,
                y: 375,
                fillStyle: c.white,
                strokeStyle: c.darkGray,
                strokeWidth: 1,
                outerStroke: {
                    color: c.darkGray,
                    width: 2
                }
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 280,
                x: 750,
                y: 410,
                fillStyle: c.white,
                strokeStyle: c.darkGray,
                strokeWidth: 2,
                outerStroke: {
                    color: c.darkGray,
                    width: 4
                }
            }],
            "jersey-swingman-black-tie": [{
                type: "text",
                fontFamily: "UnitedSansCond",
                fontSize: 75,
                x: 750,
                y: 600,
                fillStyle: c.white,
                radius: 400,
                letterSpacing: .029
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 100,
                x: 250,
                y: 350,
                fillStyle: c.darkGray
            }, {
                type: "number",
                fontFamily: "HustleTie",
                fontSize: 100,
                x: 250,
                y: 350,
                fillStyle: c.white
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 210,
                x: 750,
                y: 380,
                fillStyle: c.darkGray
            }, {
                type: "number",
                fontFamily: "HustleTie",
                fontSize: 210,
                x: 750,
                y: 380,
                fillStyle: c.white
            }],
            "jersey-swingman-legacy": [{
                type: "text",
                fontFamily: "UnitedSansCond",
                fontSize: 50,
                x: 750,
                y: 580,
                fillStyle: c.black,
                radius: 400,
                letterSpacing: .022
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 100,
                x: 340,
                y: 185,
                fillStyle: c.red,
                outerStroke: [{
                    color: c.darkGray,
                    width: 4
                }, {
                    color: c.white,
                    width: 2
                }]
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 280,
                x: 750,
                y: 380,
                fillStyle: c.red,
                outerStroke: [{
                    color: c.darkGray,
                    width: 7
                }, {
                    color: c.white,
                    width: 3
                }]
            }],
            "jersey-swingman-home-strong": [{
                type: "text",
                fontFamily: "UnitedSansCond",
                fontSize: {
                    min: 60,
                    max: 110,
                    limit: 12
                },
                x: 750,
                y: 220,
                fillStyle: c.white
            }, {
                type: "number",
                fontFamily: "HustleHomeStrongInsert",
                fontSize: 80,
                x: 120,
                y: 180,
                align: "left",
                respectAlign: !0,
                fillStyle: c.green
            }, {
                type: "number",
                fontFamily: "HustleHomeStrongInsert",
                fontSize: 250,
                x: 750,
                y: 398,
                firefox: {
                    y: 382
                },
                fillStyle: c.white
            }, {
                type: "number",
                fontFamily: "HustleHomeStrong",
                fontSize: 250,
                x: 750,
                y: 400,
                fillStyle: c.green
            }],
            "jersey-replica-miami-red-infant-onesie": [{
                type: "text",
                fontFamily: "UnitedSansCond",
                fontSize: 45,
                x: 730,
                y: 660,
                fillStyle: c.white,
                radius: 400,
                letterSpacing: .024
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 100,
                align: "right",
                respectAlign: !0,
                x: 370,
                y: 400,
                fillStyle: c.white,
                strokeStyle: c.darkGray,
                strokeWidth: 1,
                outerStroke: {
                    color: c.darkGray,
                    width: 2
                }
            }, {
                type: "number",
                fontFamily: "HustleLegacy",
                fontSize: 300,
                x: 720,
                y: 440,
                fillStyle: c.white,
                strokeStyle: c.darkGray,
                strokeWidth: 2,
                outerStroke: {
                    color: c.darkGray,
                    width: 3
                }
            }]
        };
    if (!l) {
        var p = "jersey-replica-miami-red-infant-onesie";
        window.product = {
            tags: ["custom-" + p]
        }
    }
    $(document).ready(function() {
        function t(t) {
            return t.indexOf("custom-") > -1
        }
        for (var e = {
                product: window.product,
                restrictedWords: l ? "w-e-t,wet 69,69,wet,remove,i eat ass,fuhrer,abbo,abo,abortion,abuse,addict,addicts,adult,africa,african,alla,allah,alligatorbait,amateur,american,anal,analannie,analsex,angie,angry,anus,arab,arabs,areola,argie,aroused,arse,arsehole,asian,ass,assassin,assassinate,assassination,assault,assbagger,assblaster,assclown,asscowboy,asses,assfuck,assfucker,asshat,asshole,assholes,asshore,assjockey,asskiss,asskisser,assklown,asslick,asslicker,asslover,assman,assmonkey,assmunch,assmuncher,asspacker,asspirate,asspuppies,assranger,asswhore,asswipe,athletesfoot,attack,australian,babe,babies,backdoor,backdoorman,backseat,badfuck,balllicker,balls,ballsack,banging,baptist,barelylegal,barf,barface,barfface,bast,bastard ,bazongas,bazoongas,bazooms,beaner,beast,beastality,beastial,beastiality,beatoff,beat-off,beatyourmeat,beaver,bestial,bestiality,bi,biatch,bible,bicurious,bigass,bigbastard,bigbutt,bigger,bisexual,bi-sexual,bitch,bitcher,bitches,bitchez,bitchin,bitching,bitchslap,bitchy,biteme,black,blackman,blackout,blacks,blind,blow,blowjob,boang,bogan,bohunk,bollick,bollock,bomb,bombers,bombing,bombs,bomd,bondage,boner,bong,boob,boobies,boobs,booby,boody,boom,boong,boonga,boonie,booty,bootycall,bountybar,bra,brea5t,breast,breastjob,breastlover,breastman,brothel,bugger,buggered,buggery,bullcrap,bulldike,bulldyke,bullshit,bumblefuck,bumfuck,bunga,bunghole,buried,burn,butchbabes,butchdike,butchdyke,butt,buttbang,butt-bang,buttface,buttfuck,butt-fuck,buttfucker,butt-fucker,buttfuckers,butt-fuckers,butthead,buttman,buttmunch,buttmuncher,buttpirate,buttplug,buttstain,byatch,cacker,cameljockey,cameltoe,canadian,cancer,carpetmuncher,carruth,catholic,catholics,cemetery,chav,cherrypopper,chickslick,children's,chin,chinaman,chinamen,chinese,chink,chinky,choad,chode,christ,christian,church,cigarette,cigs,clamdigger,clamdiver,clit,clitoris,clogwog,cocaine,cock,cockblock,cockblocker,cockcowboy,cockfight,cockhead,cockknob,cocklicker,cocklover,cocknob,cockqueen,cockrider,cocksman,cocksmith,cocksmoker,cocksucer,cocksuck ,cocksucked ,cocksucker,cocksucking,cocktail,cocktease,cocky,cohee,coitus,color,colored,coloured,commie,communist,condom,conservative,conspiracy,coolie,cooly,coon,coondog,copulate,cornhole,corruption,cra5h,crabs,crack,crackpipe,crackwhore,crack-whore,crap,crapola,crapper,crappy,crash,creamy,crime,crimes,criminal,criminals,crotch,crotchjockey,crotchmonkey,crotchrot,cum,cumbubble,cumfest,cumjockey,cumm,cummer,cumming,cumquat,cumqueen,cumshot,cunilingus,cunillingus,cunn,cunnilingus,cunntt,cunt,cunteyed,cuntfuck,cuntfucker,cuntlick ,cuntlicker ,cuntlicking ,cuntsucker,cybersex,cyberslimer,dago,dahmer,dammit,damn,damnation,damnit,darkie,darky,datnigga,dead,deapthroat,death,deepthroat,defecate,dego,demon,deposit,desire,destroy,deth,devil,devilworshipper,dick,dickbrain,dickforbrains,dickhead,dickless,dicklick,dicklicker,dickman,dickwad,dickweed,diddle,die,died,dies,dike,dildo,dingleberry,dink,dipshit,dipstick,dirty,disease,diseases,disturbed,dive,dix,dixiedike,dixiedyke,doggiestyle,doggystyle,dong,doodoo,doo-doo,doom,dope,dragqueen,dragqween,dripdick,drug,drunk,drunken,dumb,dumbass,dumbbitch,dumbfuck,dyefly,dyke,easyslut,eatballs,eatme,eatpussy,ecstacy,ejaculate,ejaculated,ejaculating ,ejaculation,enema,enemy,erect,erection,ero,escort,ethiopian,ethnic,european,evl,excrement,execute,executed,execution,executioner,explosion,facefucker,faeces,fag,fagging,faggot,fagot,failed,failure,fairies,fairy,faith,fannyfucker,fart,farted ,farting ,farty ,fastfuck,fat,fatah,fatass,fatfuck,fatfucker,fatso,fckcum,fear,feces,felatio ,felch,felcher,felching,fellatio,feltch,feltcher,feltching,fetish,fight,filipina,filipino,fingerfood,fingerfuck ,fingerfucked ,fingerfucker ,fingerfuckers,fingerfucking ,fire,firing,fister,fistfuck,fistfucked ,fistfucker ,fistfucking ,fisting,flange,flasher,flatulence,floo,flydie,flydye,fok,fondle,footaction,footfuck,footfucker,footlicker,footstar,fore,foreskin,forni,fornicate,foursome,fourtwenty,fraud,freakfuck,freakyfucker,freefuck,fu,fubar,fuc,fucck,fuck,fucka,fuckable,fuckbag,fuckbuddy,fucked,fuckedup,fucker,fuckers,fuckface,fuckfest,fuckfreak,fuckfriend,fuckhead,fuckher,fuckin,fuckina,fucking,fuckingbitch,fuckinnuts,fuckinright,fuckit,fuckknob,fuckme ,fuckmehard,fuckmonkey,fuckoff,fuckpig,fucks,fucktard,fuckwhore,fuckyou,fudgepacker,fugly,fuk,fuks,funeral,funfuck,fungus,fuuck,gangbang,gangbanged ,gangbanger,gangsta,gatorbait,gay,gaymuthafuckinwhore,gaysex ,geez,geezer,geni,genital,german,getiton,gin,ginzo,gipp,girls,givehead,glazeddonut,gob,god,godammit,goddamit,goddammit,goddamn,goddamned,goddamnes,goddamnit,goddamnmuthafucker,goldenshower,gonorrehea,gonzagas,gook,gotohell,goy,goyim,greaseball,gringo,groe,gross,grostulation,gubba,gummer,gun,gyp,gypo,gypp,gyppie,gyppo,gyppy,hamas,handjob,hapa,harder,hardon,harem,headfuck,headlights,hebe,heeb,hell,henhouse,heroin,herpes,heterosexual,hijack,hijacker,hijacking,hillbillies,hindoo,hiscock,hitler,hitlerism,hitlerist,hiv,ho,hobo,hodgie,hoes,hole,holestuffer,homicide,homo,homobangers,homosexual,honger,honk,honkers,honkey,honky,hook,hooker,hookers,hooters,hore,hork,horn,horney,horniest,horny,horseshit,hosejob,hoser,hostage,hotdamn,hotpussy,hottotrot,hummer,husky,hussy,hustler,hymen,hymie,iblowu,idiot,ikey,illegal,incest,insest,intercourse,interracial,intheass,inthebuff,israel,israeli,israel's,italiano,itch,jackass,jackoff,jackshit,jacktheripper,jade,jap,japanese,japcrap,jebus,jeez,jerkoff,jesus,jesuschrist,jew,jewish,jiga,jigaboo,jigg,jigga,jiggabo,jigger ,jiggy,jihad,jijjiboo,jimfish,jism,jiz ,jizim,jizjuice,jizm ,jizz,jizzim,jizzum,joint,juggalo,jugs,junglebunny,kaffer,kaffir,kaffre,kafir,kanake,kid,kigger,kike,kill,killed,killer,killing,kills,kink,kinky,kissass,kkk,knife,knockers,kock,kondum,koon,kotex,krap,krappy,kraut,kum,kumbubble,kumbullbe,kummer,kumming,kumquat,kums,kunilingus,kunnilingus,kunt,ky,kyke,lactate,laid,lapdance,latin,lesbain,lesbayn,lesbian,lesbin,lesbo,lez,lezbe,lezbefriends,lezbo,lezz,lezzo,liberal,libido,licker,lickme,lies,limey,limpdick,limy,lingerie,liquor,livesex,loadedgun,lolita,looser,loser,lotion,lovebone,lovegoo,lovegun,lovejuice,lovemuscle,lovepistol,loverocket,lowlife,lsd,lubejob,lucifer,luckycammeltoe,lugan,macaca,mad,mafia,magicwand,mamba,mams,manhater,manpaste,marijuana,mastabate,mastabater,masterbate,masterblaster,mastrabator,masturbate,masturbating,mattressprincess,meatbeatter,meatrack,meth,mexican,mgger,mggor,mickeyfinn,mideast,milf,minority,mockey,mockie,mocky,mofo,moky,moles,molest,molestation,molester,molestor,moneyshot,mooncricket,mormon,moron,moslem,mosshead,mothafuck,mothafucka,mothafuckaz,mothafucked ,mothafucker,mothafuckin,mothafucking ,mothafuckings,motherfuck,motherfucked,motherfucker,motherfuckin,motherfucking,motherfuckings,motherlovebone,muff,muffdive,muffdiver,muffindiver,mufflikcer,mulatto,muncher,munt,murder,murderer,muslim,naked,narcotic,nasty,nastybitch,nastyho,nastyslut,nastywhore,nazi,necro,negro,negroes,negroid,negro's,nig,niger,nigerian,nigerians,nigg,nigga,niggah,niggaracci,niggard,niggarded,niggarding,niggardliness,niggardliness's,niggardly,niggards,niggard's,niggaz,nigger,niggerhead,niggerhole,niggers,nigger's,niggle,niggled,niggles,niggling,nigglings,niggor,niggur,niglet,nignog,nigr,nigra,nigre,nip,nipple,nipplering,nittit,nlgger,nlggor,nofuckingway,nook,nookey,nookie,noonan,nooner,nude,nudger,nuke,nutfucker,nymph,ontherag,oral,orga,orgasim ,orgasm,orgies,orgy,osama,paki,palesimian,palestinian,pansies,pansy,panti,panties,payo,pearlnecklace,peck,pecker,peckerwood,pee,peehole,pee-pee,peepshow,peepshpw,pendy,penetration,peni5,penile,penis,penises,penthouse,period,perv,phonesex,phuk,phuked,phuking,phukked,phukking,phungky,phuq,pi55,picaninny,piccaninny,pickaninny,piker,pikey,piky,pimp,pimped,pimper,pimpjuic,pimpjuice,pimpsimp,pindick,piss,pissed,pisser,pisses ,pisshead,pissin ,pissing,pissoff ,pistol,pixie,pixy,playboy,playgirl,pocha,pocho,pocketpool,pohm,polack,pom,pommie,pommy,poo,poon,poontang,poop,pooper,pooperscooper,pooping,poorwhitetrash,popimp,porchmonkey,porn,pornflick,pornking,porno,pornography,pornprincess,pot,poverty,premature,pric,prick,prickhead,primetime,propaganda,pros,prostitute,protestant,pu55i,pu55y,pube,pubic,pubiclice,pud,pudboy,pudd,puddboy,puke,puntang,purinapricness,puss,pussie,pussies,pussy,pussycat,pussyeater,pussyfucker,pussylicker,pussylips,pussylover,pussypounder,pusy,quashie,queef,queer,quickie,quim,ra8s,rabbi,racial,racist,radical,radicals,raghead,randy,rape,raped,raper,rapist,rearend,rearentry,rectum,redlight,redneck,reefer,reestie,refugee,reject,remains,rentafuck,republican,rere,retard,retarded,ribbed,rigger,rimjob,rimming,roach,robber,roundeye,rump,russki,russkie,sadis,sadom,samckdaddy,sandm,sandnigger,satan,scag,scallywag,scat,schlong,third reich,screw,screwyou,scrotum,scum,semen,seppo,servant,sex,sexed,sexfarm,sexhound,sexhouse,sexing,sexkitten,sexpot,sexslave,sextogo,sextoy,sextoys,sexual,sexually,sexwhore,sexy,sexymoma,sexy-slim,shag,shaggin,shagging,shat,shav,shawtypimp,sheeney,shhit,shinola,shit,shitcan,shitdick,shite,shiteater,shited,shitface,shitfaced,shitfit,shitforbrains,shitfuck,shitfucker,shitfull,shithapens,shithappens,shithead,shithouse,shiting,shitlist,shitola,shitoutofluck,shits,shitstain,shitted,shitter,shitting,shitty ,shoot,shooting,shortfuck,showtime,sick,sissy,sixsixsix,sixtynine,sixtyniner,skank,skankbitch,skankfuck,skankwhore,skanky,skankybitch,skankywhore,skinflute,skum,skumbag,slant,slanteye,slapper,slaughter,slav,slave,slavedriver,sleezebag,sleezeball,slideitin,slime,slimeball,slimebucket,slopehead,slopey,slopy,slut,sluts,slutt,slutting,slutty,slutwear,slutwhore,smack,smackthemonkey,smut,snatch,snatchpatch,snigger,sniggered,sniggering,sniggers,snigger's,sniper,snot,snowback,snownigger,sob,sodom,sodomise,sodomite,sodomize,sodomy,sonofabitch,sonofbitch,sooty,sos,soviet,spaghettibender,spaghettinigger,spank,spankthemonkey,sperm,spermacide,spermbag,spermhearder,spermherder,spic,spick,spig,spigotty,spik,spit,spitter,splittail,spooge,spreadeagle,spunk,spunky,squaw,stagg,stiffy,strapon,stringer,stripclub,stroke,stroking,stupid,stupidfuck,stupidfucker,suck,suckdick,sucker,suckme,suckmyass,suckmydick,suckmytit,suckoff,suicide,swallow,swallower,swalow,swastika,sweetness,syphilis,taboo,taff,tampon,tang,tantra,tarbaby,tard,teat,terror,terrorist,teste,testicle,testicles,thicklips,thirdeye,thirdleg,threesome,threeway,timbernigger,tinkle,tit,titbitnipply,titfuck,titfucker,titfuckin,titjob,titlicker,titlover,tits,tittie,titties,titty,tnt,toilet,tongethruster,tongue,tonguethrust,tonguetramp,tortur,torture,tosser,towelhead,trailertrash,tramp,trannie,tranny,transexual,transsexual,transvestite,triplex,trisexual,trojan,trots,tuckahoe,tunneloflove,turd,turnon,twat,twink,twinkie,twobitwhore,uck,uk,unfuckable,upskirt,uptheass,upthebutt,urinary,urinate,urine,usama,uterus,vagina,vaginal,vatican,vibr,vibrater,vibrator,vietcong,violence,virgin,virginbreaker,vomit,vulva,wab,wank,wanker,wanking,waysted,weapon,weenie,weewee,welcher,welfare,wetb,wetback,wetspot,whacker,whash,whigger,whiskey,whiskeydick,whiskydick,whit,whitenigger,whites,whitetrash,whitey,whiz,whop,whore,whorefucker,whorehouse,wigger,willie,williewanker,wn,wog,women's,wop,wtf,wuss,wuzzie,xtc,xxx,yankee,yellowman,zigabo,zipperhead,Asesinato,asno,bastardo,Bollera,Cabron,Cabrón,Caca,Chupada,Chupapollas,Chupetón,concha,Concha de tu madre,Coño,Coprofagía,Culo,Drogas,Esperma,Fiesta de salchichas,Follador,Follar,Gilipichis,Gilipollas,Hacer una paja,Haciendo el amor,Heroína,Hija de puta,Hijaputa,Hijo de puta,Hijoputa,Idiota,Imbécil,infierno,Jilipollas,Kapullo,Lameculos,Maciza,Macizorra,maldito,Mamada,Marica,Maricón,Mariconazo,martillo,Mierda,Nazi,Orina,Pedo,Pervertido,Pezón,Pinche,Pis,Prostituta,Puta,Racista,Ramera,Sádico,Semen,Sexo,Sexo oral,Soplagaitas,Soplapollas,Tetas grandes,Tía buena,Travesti,Trio,Verga,vete a la mierda,Vulva,2g1c,2 girls 1 cup,acrotomophilia,alabama hot pocket,alaskan pipeline,anal,anilingus,anus,apeshit,arsehole,ass,asshole,assmunch,auto erotic,autoerotic,babeland,baby batter,baby juice,ball gag,ball gravy,ball kicking,ball licking,ball sack,ball sucking,bangbros,bareback,barely legal,barenaked,bastard,bastardo,bastinado,bbw,bdsm,beaner,beaners,beaver cleaver,beaver lips,bestiality,big black,big breasts,big knockers,big tits,bimbos,birdlock,bitch,bitches,black cock,blonde action,blonde on blonde action,blowjob,blow job,blow your load,blue waffle,blumpkin,bollocks,bondage,boner,boob,boobs,booty call,brown showers,brunette action,bukkake,bulldyke,bullet vibe,bullshit,bung hole,bunghole,busty,butt,buttcheeks,butthole,camel toe,camgirl,camslut,camwhore,carpet muncher,carpetmuncher,chocolate rosebuds,circlejerk,cleveland steamer,clit,clitoris,clover clamps,clusterfuck,cock,cocks,coprolagnia,coprophilia,cornhole,coon,coons,creampie,cum,cumming,cunnilingus,cunt,darkie,date rape,daterape,deep throat,deepthroat,dendrophilia,dick,dildo,dingleberry,dingleberries,dirty pillows,dirty sanchez,doggie style,doggiestyle,doggy style,doggystyle,dog style,dolcett,domination,dominatrix,dommes,donkey punch,double dong,double penetration,dp action,dry hump,dvda,eat my ass,ecchi,ejaculation,erotic,erotism,escort,eunuch,faggot,fecal,felch,fellatio,feltch,female squirting,femdom,figging,fingerbang,fingering,fisting,foot fetish,footjob,frotting,fuck,fuck buttons,fuckin,fucking,fucktards,fudge packer,fudgepacker,futanari,gang bang,gay sex,genitals,giant cock,girl on,girl on top,girls gone wild,goatcx,goatse,goat,god damn,gokkun,golden shower,goodpoop,goo girl,goregasm,grope,group sex,g-spot,guro,hand job,handjob,hard core,hardcore,hentai,homoerotic,honkey,hooker,hot carl,hot chick,how to kill,how to murder,huge fat,humping,incest,intercourse,jack off,jail bait,jailbait,jelly donut,jerk off,jigaboo,jiggaboo,jiggerboo,jizz,juggs,kike,kinbaku,kinkster,kinky,knobbing,leather restraint,leather straight jacket,lemon party,lolita,lovemaking,make me come,male squirting,masturbate,menage a trois,milf,missionary position,motherfucker,mound of venus,mr hands,muff diver,muffdiving,nambla,nawashi,negro,neonazi,nigga,nigger,nig nog,nimphomania,nipple,nipples,nsfw images,nude,nudity,nympho,nymphomania,octopussy,omorashi,one cup two girls,one guy one jar,orgasm,orgy,paedophile,paki,panties,panty,pedobear,pedophile,pegging,penis,phone sex,piece of shit,pissing,piss pig,pisspig,playboy,pleasure chest,pole smoker,ponyplay,poof,poon,poontang,punany,poop chute,poopchute,porn,porno,pornography,prince albert piercing,pthc,pubes,pussy,queaf,queef,quim,raghead,raging boner,rape,raping,rapist,rectum,reverse cowgirl,rimjob,rimming,rosy palm,rosy palm and her 5 sisters,rusty trombone,sadism,santorum,scat,schlong,scissoring,semen,sex,sexo,sexy,shaved beaver,shaved pussy,shemale,shibari,shit,shitblimp,shitty,shota,shrimping,skeet,slanteye,slut,s&m,smut,snatch,snowballing,sodomize,sodomy,spic,splooge,splooge moose,spooge,spread legs,spunk,strap on,strapon,strappado,strip club,style doggy,suck,sucks,suicide girls,sultry women,swastika,swinger,tainted love,taste my,tea bagging,thegoat,threesome,throating,tied up,tight white,tit,tits,titties,titty,tongue in a,topless,tosser,towelhead,tranny,tribadism,tub girl,tubgirl,tushy,twat,twink,twinkie,two girls one cup,undressing,upskirt,urethra play,urophilia,vagina,venus mound,vibrator,violet wand,vorarephilia,voyeur,vulva,wank,wetback,wet dream,white power,wrapping men,wrinkled starfish,xx,xxx,yaoi,yellow showers,yiffy,zoophilia,noob,pinga,pene,pichula,chucha,concha".split(",") : ["test", "hola"]
            }, r = 0; r < e.restrictedWords.length; r++) e.restrictedWords[r] = e.restrictedWords[r].trim().toLowerCase();
        if (e.product && e.product.tags && e.product.tags.find(t)) {
            var c = e.product.tags[e.product.tags.indexOf(e.product.tags.find(t))].replace("custom-", "");
            if (!f[c]) throw new Error("Invalid tag!");
            var p = f[c],
                h = void 0;
            switch (c) {
                case "jersey-replica-home-white":
                    h = "//www.miamiheatstore.com/cdn/shop/t/27/assets/custom-jersey-replica-home-white.jpg?v=32033418856688504711619033743";
                    break;
                case "jersey-replica-miami-red":
                    h = "//www.miamiheatstore.com/cdn/shop/t/27/assets/custom-jersey-replica-miami-red.jpg?v=28853054426079238161619033745";
                    break;
                case "jersey-replica-miami-black":
                    h = "//www.miamiheatstore.com/cdn/shop/t/27/assets/custom-jersey-replica-miami-black.jpg?v=115686842844686135311619033744";
                    break;
                case "jersey-swingman-home-white":
                    h = "//www.miamiheatstore.com/cdn/shop/t/27/assets/custom-jersey-swingman-home-white.jpg?v=82864287275220801191619033748";
                    break;
                case "jersey-swingman-miami-red":
                    h = "//www.miamiheatstore.com/cdn/shop/t/27/assets/custom-jersey-swingman-miami-red.jpg?v=84941009089817096081619033749";
                    break;
                case "jersey-swingman-miami-black":
                    h = "//www.miamiheatstore.com/cdn/shop/t/27/assets/custom-jersey-swingman-miami-black.jpg?v=13832033048078691891619033749";
                    break;
                case "jersey-swingman-elheat-white":
                    h = "//www.miamiheatstore.com/cdn/shop/t/27/assets/custom-jersey-swingman-elheat-white.jpg?v=30805424201801595691619033746";
                    break;
                case "jersey-swingman-elheat-red":
                    h = "//www.miamiheatstore.com/cdn/shop/t/27/assets/custom-jersey-swingman-elheat-red.jpg?v=29647382386568605671619033746";
                    break;
                case "jersey-swingman-black-tie":
                    h = "//www.miamiheatstore.com/cdn/shop/t/27/assets/custom-jersey-swingman-black-tie.jpg?v=126391813993867938621619033745";
                    break;
                case "jersey-swingman-legacy":
                    h = "//www.miamiheatstore.com/cdn/shop/t/27/assets/custom-jersey-swingman-legacy.jpg?v=175147182554338225321619033748";
                    break;
                case "jersey-swingman-home-strong":
                    h = "//www.miamiheatstore.com/cdn/shop/t/27/assets/custom-jersey-swingman-home-strong.jpg?v=108421393024960896661619033747";
                    break;
                case "jersey-replica-miami-red-infant-onesie":
                    h = "//www.miamiheatstore.com/cdn/shop/t/27/assets/custom-jersey-replica-miami-red-infant-onesie.jpg?v=90549137303378538621619033744";
                    break;
          		case "jersey-swingman-vice-black":
          			h = "//www.miamiheatstore.com/cdn/shop/t/27/assets/CustomViceBlack_5923c8c8-9be3-49cf-ba71-58136443ce4e_grande.jpg?v=56614272950977087661619033755";
                    break;
          		case "jersey-swingman-vicewave":
          			h = "//www.miamiheatstore.com/cdn/shop/t/27/assets/CustomJereys_EarnedEdition_Retail_1080x1080.jpg?v=179021325380548220491626462575";
                    break;
          		case "jersey-vicewave":
          			h = "//www.miamiheatstore.com/cdn/shop/t/27/assets/custom-vicewave-jersey.jpg?v=76101";
                    break;
                default:
                    alert("Image for 'custom-" + c + "' not found!")
            }
            l || (h = h.replace("//www.miamiheatstore.com/cdn/shop/t/27/assets/%22,%20%22/images/apparel/%22),%20h%20=%20h.replace(%22?v=76101", ""));
            var y = $("#AddToCart"),
                d = $("#CustomizerCanvas"),
                v = $("#CustomizerNumber"),
                b = $("#CustomizerName"),
                g = new a.TextValidator;
            g.maxlength = 13, l && (g.restrictedWords = e.restrictedWords);
            var m = new s.NumberValidator;
            m.maxlength = 2;
            var w = v.val().length < 1 ? "00" : v.val(),
                S = b.val().length < 1 ? "Your  Name" : b.val(),
                j = new n.Customizer({
                    canvas: d,
                    image: h,
                    number: w,
                    text: (new o.TextProcessor).process(S),
                    skin: p
                }),
                O = new u.Updater({
                    input: v,
                    customizer: j,
                    validator: m,
                    processor: new i.NumberProcessor
                }),
                x = new u.Updater({
                    input: b,
                    customizer: j,
                    validator: g,
                    processor: new o.TextProcessor
                });
            y.on("click", function(t) {
                O.update(), x.update(), (O.hasErrors || x.hasErrors) && (alert("Please fix the form errors before add the product to cart"), t.preventDefault())
            }), d.on("contextmenu", function() {
                return !1
            })
        }
        $("input[maxlength]").on("keydown", function(t) {
            var e = $(this).val().length,
                r = parseInt($(this).attr("maxlength"));
            e >= r && $(this).val($(this).val().substr(0, r))
        })
    })
}, function(t, e) {
    "use strict";
    var r = function() {
        function t(t) {
            if (!t.canvas.length) throw console.log(t.canvas), new Error("The canvas '" + t.canvas + "' was't found");
            this.canvas = t.canvas, this.image = t.image, this.number = t.number.toString(), this.text = t.text, this.skin = t.skin, this.draw({
                text: this.text,
                number: this.number
            })
        }
        return Object.defineProperty(t.prototype, "canvas", {
            get: function() {
                return this._canvas
            },
            set: function(t) {
                this._canvas = t
            },
            enumerable: !0,
            configurable: !0
        }), Object.defineProperty(t.prototype, "image", {
            get: function() {
                return this._image
            },
            set: function(t) {
                this._image = t
            },
            enumerable: !0,
            configurable: !0
        }), Object.defineProperty(t.prototype, "number", {
            get: function() {
                return this._number
            },
            set: function(t) {
                this._number = t
            },
            enumerable: !0,
            configurable: !0
        }), Object.defineProperty(t.prototype, "text", {
            get: function() {
                return this._text
            },
            set: function(t) {
                this._text = t
            },
            enumerable: !0,
            configurable: !0
        }), Object.defineProperty(t.prototype, "skin", {
            get: function() {
                return this._skin
            },
            set: function(t) {
                this._skin = t
            },
            enumerable: !0,
            configurable: !0
        }), Object.defineProperty(t.prototype, "picture", {
            get: function() {
                return this._picture
            },
            set: function(t) {
                this._picture = t
            },
            enumerable: !0,
            configurable: !0
        }), t.prototype.loadImage = function(t, e) {
            var r = this;
            if (this.picture) e();
            else {
                var n = new Image;
                n.src = t, n.onload = function() {
                    r.picture = n, e()
                }
            }
        }, t.prototype.draw = function(t) {
            var e = this,
                r = t.text || this.text,
                n = t.number || this.number;
            this.loadFonts(function() {
                e.loadImage(e.image, function() {
                    e.clear(), e.drawImage(e.picture), e.skin.forEach(function(t) {
                        switch (t.type) {
                            case "text":
                                e.drawText(r, t), e.text = r;
                                break;
                            case "number":
                                e.drawText(n, t), e.number = n;
                                break;
                            default:
                                throw new Error("The type '" + t.type + "' isn't valid")
                        }
                    })
                })
            })
        }, t.prototype.drawImage = function(t) {
            this.canvas.drawImage({
                source: t,
                x: 0,
                y: 0,
                width: 1050,
                height: 1050,
                fromCenter: !1
            })
        }, t.prototype.drawText = function(t, e) {
            var r = this;
            t = t.toString().replace(/I/g, "l");
            var n = e.fontSize,
                o = e.x,
                i = e.y;
            n = n || 10, o = o || 10, i = i || 10;
            var a = {
                    fillStyle: "#000",
                    letterSpacing: .1
                },
                s = {
                    fontSize: n,
                    text: t,
                    x: o,
                    y: i
                },
                u = e || {},
                c = Object.assign(a, u, s);
            if (c.firefox && navigator.userAgent.toLowerCase().indexOf("firefox") > -1 && (console.log(c), c = Object.assign(c, c.firefox), console.log(c)), "object" == typeof c.fontSize) {
                var l = 100 * (c.fontSize.limit - t.toString().length) / c.fontSize.limit,
                    f = c.fontSize.max - c.fontSize.min;
                c.fontSize = l * f / 100 + c.fontSize.min
            }
            if (c.outerStroke) {
                if (!Array.isArray(c.outerStroke)) {
                    var p = c.outerStroke;
                    c.outerStroke = [], c.outerStroke.push(p)
                }
                var h = Object.assign({}, c);
                c.outerStroke.forEach(function(t) {
                    h.x = c.x, h.y = c.y, h.fillStyle = t.color, r.outerStroke(h, t.width)
                })
            }
            this.canvas.drawText(c)
        }, t.prototype.clear = function() {
            this.canvas.clearCanvas()
        }, t.prototype.outerStroke = function(t, e) {
            for (var r = t.x, n = t.y, o = 0; o <= e; o++) {
                t.y = n - o;
                for (var i = 0; i <= e; i++) t.x = r - i, this.canvas.drawText(t);
                for (var a = 0; a <= e; a++) t.x = r + a, this.canvas.drawText(t)
            }
            for (var o = 0; o <= e; o++) {
                t.y = n + o;
                for (var i = 0; i <= e; i++) t.x = r - i, this.canvas.drawText(t);
                for (var a = 0; a <= e; a++) t.x = r + a, this.canvas.drawText(t)
            }
        }, t.prototype.loadFonts = function(t) {
            var e = [];
            this.skin.forEach(function(t) {
                t.fontFamily && e.indexOf(t.fontFamily) < 0 && e.push(t.fontFamily)
            }), this.fontRecursiveLoader(0, e, t)
        }, t.prototype.fontRecursiveLoader = function(t, e, r) {
            var n = this;
            t == e.length ? r() : this.loadFont(e[t], function() {
                t++, n.fontRecursiveLoader(t, e, r)
            })
        }, t.prototype.loadFont = function(t, e) {
            fontSpy(t, {
                success: function() {
                    e()
                },
                failure: function() {
                    var e = "Font '" + t + "' not found!";
                    throw alert(e), new Error(e)
                }
            })
        }, Object.defineProperty(t.prototype, "canvasWidth", {
            get: function() {
                return this.canvas.width()
            },
            enumerable: !0,
            configurable: !0
        }), Object.defineProperty(t.prototype, "canvasHeight", {
            get: function() {
                return this.canvas.height()
            },
            enumerable: !0,
            configurable: !0
        }), t.prototype.updateText = function(t) {
            this.draw({
                text: t
            })
        }, t.prototype.updateNumber = function(t) {
            this.draw({
                number: t
            })
        }, t.prototype.convertToImage = function() {
            return Canvas2Image.convertToJPEG(this.canvas[0], this.canvasWidth, this.canvasHeight)
        }, t.prototype.done = function() {
            return this.convertToImage()
        }, t
    }();
    e.Customizer = r
}, function(t, e, r) {
    "use strict";
    var n = this && this.__extends || function(t, e) {
            function r() {
                this.constructor = t
            }
            for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
            t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r)
        },
        o = r(6),
        i = function(t) {
            function e() {
                t.call(this), this.type = "text"
            }
            return n(e, t), e.prototype.clean = function(t) {
                return t = t.replace(/  +/g, " "), t = t.trim()
            }, e.prototype.process = function(t) {
                var e = t.toUpperCase();
                return e
            }, e
        }(o.Processor);
    e.TextProcessor = i
}, function(t, e) {
    "use strict";
    var r = function() {
        function t() {
            this.$type = "generic"
        }
        return Object.defineProperty(t.prototype, "type", {
            get: function() {
                return this.$type
            },
            set: function(t) {
                this.$type = t
            },
            enumerable: !0,
            configurable: !0
        }), t.prototype.clean = function(t) {
            return t
        }, t.prototype.process = function(t) {
            return t
        }, t
    }();
    e.Processor = r
}, function(t, e, r) {
    "use strict";
    var n = this && this.__extends || function(t, e) {
            function r() {
                this.constructor = t
            }
            for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
            t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r)
        },
        o = r(6),
        i = function(t) {
            function e() {
                t.call(this), this.type = "number"
            }
            return n(e, t), e.prototype.process = function(t) {
                return "00" !== t && (t = parseInt(t).toString()), t
            }, e
        }(o.Processor);
    e.NumberProcessor = i
}, function(t, e, r) {
    "use strict";
    var n = this && this.__extends || function(t, e) {
            function r() {
                this.constructor = t
            }
            for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
            t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r)
        },
        o = r(9),
        i = function(t) {
            function e() {
                t.call(this), this._restrictedWords = [], this.type = "text", this.reg = new RegExp("^[.'üéáíóúÁÉÍÓÚÜñÑA-Za-z- #]+$"), this.repeatedChars = /^(.)\1{4}/
            }
            return n(e, t), Object.defineProperty(e.prototype, "restrictedWords", {
                get: function() {
                    return this._restrictedWords
                },
                set: function(t) {
                    this._restrictedWords = t
                },
                enumerable: !0,
                configurable: !0
            }), e.prototype.validate = function(t) {
                return this.error = null, this.generalValidation(t), t ? this.regTest(t) ? this.repeatedChars && this.repeatedChars.test(t) ? void(this.error = "The value is incorrect") : this.restrictedWords.indexOf(t.toLowerCase()) > -1 || this.restrictedWords.indexOf(t.toLowerCase().replace(/ +/g, "")) > -1 ? void(this.error = "We are unable to customize this item with the text you have entered. Please try a different entry again.") : void 0 : void(this.error = "The value must be a letter") : void(this.error = "Please enter a Name")
            }, e
        }(o.Validator);
    e.TextValidator = i
}, function(t, e) {
    "use strict";
    var r = function() {
        function t() {
            this.$type = "generic"
        }
        return Object.defineProperty(t.prototype, "type", {
            get: function() {
                return this.$type
            },
            set: function(t) {
                this.$type = t
            },
            enumerable: !0,
            configurable: !0
        }), Object.defineProperty(t.prototype, "reg", {
            get: function() {
                return this.$reg
            },
            set: function(t) {
                this.$reg = t
            },
            enumerable: !0,
            configurable: !0
        }), Object.defineProperty(t.prototype, "error", {
            get: function() {
                return this.$error
            },
            set: function(t) {
                this.$error = t
            },
            enumerable: !0,
            configurable: !0
        }), Object.defineProperty(t.prototype, "maxlength", {
            get: function() {
                return this._maxlength
            },
            set: function(t) {
                this._maxlength = t
            },
            enumerable: !0,
            configurable: !0
        }), Object.defineProperty(t.prototype, "hasError", {
            get: function() {
                return null != this.error && void 0 != this.error && this.error.length > 0
            },
            enumerable: !0,
            configurable: !0
        }), t.prototype.regTest = function(t) {
            return this.reg.test(t)
        }, t.prototype.validate = function(t) {}, t.prototype.generalValidation = function(t) {
            if (this.maxlength && this.maxlength > 0 && t.toString().length > this.maxlength) return void(this.error = "The value exceeds the maximum characters allowed")
        }, t
    }();
    e.Validator = r
}, function(t, e, r) {
    "use strict";
    var n = this && this.__extends || function(t, e) {
            function r() {
                this.constructor = t
            }
            for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
            t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r)
        },
        o = r(9),
        i = function(t) {
            function e() {
                t.call(this), this.type = "number", this.reg = new RegExp("^[0-9]+$")
            }
            return n(e, t), e.prototype.validate = function(t) {
                if (this.error = null, this.generalValidation(t), !this.regTest(t)) return void(this.error = "The value must be a number")
            }, e
        }(o.Validator);
    e.NumberValidator = i
}, function(t, e) {
    "use strict";
    var r = function() {
        function t(t) {
            this.interval = 0, this.input = t.input, this.customizer = t.customizer, this.validator = t.validator, this.processor = t.processor;
            var e = this.input.parents("[customizer-label-wrapper]").find(".error");
            if (!e.length) throw new Error("'error' element not found");
            this.errorWrapper = e, this.listening()
        }
        return Object.defineProperty(t.prototype, "hasErrors", {
            get: function() {
                return this.errors
            },
            set: function(t) {
                this.errors = t
            },
            enumerable: !0,
            configurable: !0
        }), t.prototype.listening = function() {
            var t = this;
            this.input.on("keyup", function() {
                t.update()
            })
        }, t.prototype.update = function() {
            var t = this;
            this.errorWrapper.html("");
            var e = this.processor.clean(this.input.val());
            this.validator.validate(e), this.validator.hasError ? (this.hasErrors = !0, this.errorWrapper.html(this.validator.error)) : (this.hasErrors = !1, e = this.processor.process(e), clearTimeout(this.timer), this.timer = setTimeout(function() {
                switch (t.validator.type) {
                    case "text":
                        t.customizer.updateText(e);
                        break;
                    case "number":
                        t.customizer.updateNumber(e)
                }
            }, this.interval))
        }, t
    }();
    e.Updater = r
}]);